/*
 * COVRED Cart Drawer
 * Custom events émis :
 *   - cart:item-added     → après un ajout au panier réussi
 *   - ajaxProduct:added   → legacy, même trigger que cart:item-added
 *   - cart:refresh         → demande de rafraîchir le drawer
 *   - cart:updated         → après re-rendu du drawer
 *   - cart-drawer:updated  → idem, alias
 */
(function () {
  'use strict';

  /* Messages — read from data-attributes on #CartDrawer, set in cart-drawer.liquid */
  var _drawerEl = document.getElementById('CartDrawer');
  var MSG = {
    offer: (_drawerEl && _drawerEl.dataset.msgOffer) || '',
    added: (_drawerEl && _drawerEl.dataset.msgAdded) || 'AJOUTÉ ✓',
    protection: (_drawerEl && _drawerEl.dataset.msgProtection) || 'Protection activée ✓',
    error: (_drawerEl && _drawerEl.dataset.msgError) || 'Erreur, réessayez'
  };

  var SEL = {
    drawer: '#CartDrawer',
    overlay: '.cart-drawer__overlay',
    panel: '.cart-drawer__panel',
    closeBtn: '.cart-drawer__close',

    itemsWrap: '#CartDrawerItems',
    upsellCard: '#CartDrawerUpsellCard',
    warrantySlot: '#CartDrawerWarrantySlot',
    empty: '#CartDrawerEmpty',
    subtotal: '#CartDrawerSubtotal',
    itemTpl: '#CartDrawerItemTpl',

    discountWrap: '.cart-drawer__discount',
    discountToggle: '.cart-drawer__discount-toggle',
    discountInput: '#CartDrawerDiscount',
    discountBtn: '#CartDrawerApplyDiscount',
    discountMsg: '#CartDrawerDiscountMsg',
    savings: '#CartDrawerSavings'
  };
  var UPSELL_DISCOUNT_CODE = (window.COVRED_UPSELL_DISCOUNT_CODE || 'UPSELL');
  var _pc = (window.COVRED && window.COVRED.promoCodes) || {};
  var DRAWER_PROMO_CODE_2 = _pc.step2 || 'COVRED24';
  var DRAWER_PROMO_CODE_3 = _pc.step3 || 'COVREDGOAT';
  var EMPTY_PROMO_CODE_4 = _pc.step4 || 'GAKNHT85SRVA';
  var EMPTY_PROMO_CODE_5 = _pc.step5 || '8PY09B7JER1K';
  var DRAWER_PROMO_CODE_9 = _pc.step9 || 'COVREDBONITO';
  var DRAWER_PROMO_OFFER_BY_STEP = {
    2: { reward: '-10%', code: DRAWER_PROMO_CODE_2 },
    3: { reward: '-15%', code: DRAWER_PROMO_CODE_3 },
    4: { reward: '-15€', code: EMPTY_PROMO_CODE_4 },
    5: { reward: '-21,99€', code: EMPTY_PROMO_CODE_5 },
    9: { reward: '-50€', code: DRAWER_PROMO_CODE_9 }
  };
  var DRAWER_PROMO_MIN_QTY_BY_CODE = {};
  DRAWER_PROMO_MIN_QTY_BY_CODE[String(DRAWER_PROMO_CODE_2).toUpperCase()] = 2;
  DRAWER_PROMO_MIN_QTY_BY_CODE[String(DRAWER_PROMO_CODE_3).toUpperCase()] = 3;
  DRAWER_PROMO_MIN_QTY_BY_CODE[String(EMPTY_PROMO_CODE_4).toUpperCase()] = 4;
  DRAWER_PROMO_MIN_QTY_BY_CODE[String(EMPTY_PROMO_CODE_5).toUpperCase()] = 5;
  DRAWER_PROMO_MIN_QTY_BY_CODE[String(DRAWER_PROMO_CODE_9).toUpperCase()] = 9;
  var EMPTY_PROMO_CODE_4_UPPER = EMPTY_PROMO_CODE_4.toUpperCase();
  var EMPTY_PROMO_CODE_5_UPPER = EMPTY_PROMO_CODE_5.toUpperCase();
  var BASE_JERSEY_PRICE_CENTS = parseInt(window.COVRED_BASE_JERSEY_CENTS || '1999', 10) || 1999;
  var UPSELL_SESSION_KEY = 'covred_upsell_offer_active';
  var UPSELL_SIZE_KEY = 'covred_upsell_selected_size';
  var UPSELL_TIMER_KEY = 'covred_upsell_deadline_ts';
  var UPSELL_TIMER_EXPIRED_KEY = 'covred_upsell_timer_expired';
  var UPSELL_AB_KEY = 'covred_upsell_ab_variant';
  var UPSELL_CARD_INDEX_KEY = 'covred_upsell_card_index';
  var UPSELL_JUST_ADDED_UNTIL_KEY = 'covred_upsell_just_added_until_ts';
  var UPSELL_INVALID_NOTICE_SHOWN_KEY = 'covred_upsell_invalid_notice_shown';
  var UPSELL_JUST_ADDED_WINDOW_MS = 2200;
  /* [PHASE 5A.1] Constantes WARRANTY_OPTIONS + WARRANTY_BY_VARIANT_ID supprimées — code mort. */

  // -------------------------
  // Helpers + caches
  // -------------------------
  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }

  // Cache DOM (revalide si le drawer change)
  var DOM = null;
  var drawerOpenSequence = 0;

  /* [PHASE 3B.6] Helper unique pour créer/récupérer un slot DOM dans le drawer.
     Avant : 4 fonctions ensureXxxSlot avec la même structure (~15 lignes chacune,
     60 lignes au total). Maintenant : 1 helper ensureSlot + 4 wrappers minimaux.
     IMPACT: -45 lignes, plus facile à maintenir, comportement identique. */
  function ensureSlot(drawer, opts) {
    if (!drawer) return null;
    var existing = qs('#' + opts.id, drawer);
    if (existing) return existing;
    var anchor = opts.anchorSelector ? qs(opts.anchorSelector, drawer) : null;
    if (opts.requireAnchor && !anchor) return null;
    var el = document.createElement(opts.tag || 'div');
    el.id = opts.id;
    if (opts.className) el.className = opts.className;
    el.style.display = 'none';
    if (anchor) {
      anchor.insertAdjacentElement(opts.position || 'afterend', el);
    } else if (opts.fallbackParentSelector) {
      var parent = qs(opts.fallbackParentSelector, drawer);
      if (parent) parent.appendChild(el);
      else return null;
    } else {
      return null;
    }
    return el;
  }

  function ensureUpsellCard(drawer) {
    /* WHY: garantir qu'une zone "carte upsell" existe entre les lignes panier et le footer.
       IMPACT: l'upsell est présente visuellement comme une carte, pas comme un bouton bas. */
    return ensureSlot(drawer, {
      id: 'CartDrawerUpsellCard',
      className: 'cart-drawer__upsell-card',
      anchorSelector: '#CartDrawerItems',
      position: 'afterend',
      requireAnchor: true
    });
  }

  /* [PHASE 5A.1] ensureWarrantySlot supprimé — code warranty supprimé. Le slot DOM
     #CartDrawerWarrantySlot n'est plus créé côté JS. Si un slot existait déjà dans le Liquid,
     il reste présent mais inutilisé et sera masqué via le branch empty (innerHTML = ''). */

  function ensureProgressSlot(drawer) {
    return ensureSlot(drawer, {
      id: 'CartDrawerProgressSlot',
      className: 'cart-drawer__progress-slot',
      anchorSelector: '.cart-drawer__footer .cart-drawer__subtotal-wrap',
      position: 'afterend',
      requireAnchor: true
    });
  }

  function ensureSavingsSlot(drawer) {
    return ensureSlot(drawer, {
      id: 'CartDrawerSavings',
      tag: 'p',
      anchorSelector: '.cart-drawer__footer .cart-drawer__subtotal-wrap',
      position: 'afterend',
      requireAnchor: true
    });
  }

  function ensureDrawerMarketingRuntimeStyles() {
    if (document.getElementById('CovredDrawerMarketingStyle')) return;
    var style = document.createElement('style');
    style.id = 'CovredDrawerMarketingStyle';
    style.textContent =
      '#CartDrawer #CartDrawerEmpty{padding:8px 0 2px;border:0 !important;outline:0 !important;opacity:1 !important;filter:none !important;mix-blend-mode:normal !important;position:relative;z-index:3;}' +
      '#CartDrawer.is-loading #CartDrawerEmpty{opacity:1 !important;filter:none !important;}' +
      '#CartDrawer.is-loading #CartDrawerEmpty *{opacity:1 !important;filter:none !important;}' +
      '#CartDrawer .cart-drawer__empty-shell{display:grid;gap:8px;position:relative;z-index:5;isolation:isolate;opacity:1 !important;filter:none !important;}' +
      '#CartDrawer .cart-drawer__empty-hero{position:relative;overflow:hidden;border:1px solid rgba(255,255,255,.14);border-radius:14px;padding:11px 12px;background:var(--cd-ink-grad);box-shadow:0 10px 22px rgba(4,8,14,.22);}' +
      '#CartDrawer .cart-drawer__empty-title{margin:0;font-size:18px;font-weight:900;line-height:1.08;letter-spacing:.005em;color:#f3f8ff;max-width:100%;text-transform:uppercase;}' +
      '#CartDrawer .cart-drawer__empty-sub{margin:5px 0 0;font-size:12px;line-height:1.3;color:rgba(223,232,245,.86);max-width:94%;}' +
      '#CartDrawer .cart-drawer__empty-badges{display:flex;flex-wrap:wrap;gap:5px;margin-top:8px;}' +
      '#CartDrawer .cart-drawer__empty-badge{display:inline-flex;align-items:center;height:19px;padding:0 8px;border-radius:999px;border:1px solid rgba(255,255,255,.16);background:rgba(255,255,255,.07);font-size:9px;font-weight:800;letter-spacing:.02em;text-transform:uppercase;color:#dce7f7;}' +
      '#CartDrawer .cart-drawer__empty-offers{display:grid;gap:7px;position:relative;z-index:6;opacity:1 !important;filter:none !important;}' +
      '#CartDrawer .cart-drawer__empty-offer{position:relative;border:1px solid #e2e7ef;border-radius:13px;padding:10px 11px;background:#fff;display:grid;grid-template-columns:minmax(0,1fr) auto;gap:10px;align-items:start;box-shadow:0 8px 18px rgba(15,22,36,.06);animation:cd-empty-offer-in .26s cubic-bezier(.22,.8,.2,1);opacity:1 !important;filter:none !important;}' +
      '#CartDrawer .cart-drawer__empty-offer::before{display:none !important;content:none !important;}' +
      '#CartDrawer .cart-drawer__empty-offer-main{min-width:0;}' +
      '#CartDrawer .cart-drawer__empty-offer-kicker{margin:0;font-size:9px;font-weight:900;letter-spacing:.07em;text-transform:uppercase;color:#6c798a;}' +
      '#CartDrawer .cart-drawer__empty-offer-title{margin:3px 0 0;font-size:18px;font-weight:900;line-height:1;color:#111722;letter-spacing:-.01em;}' +
      '#CartDrawer .cart-drawer__empty-offer-sub{margin:4px 0 0;font-size:11px;color:#5f6b7b;line-height:1.25;max-width:95%;}' +
      '#CartDrawer .cart-drawer__empty-offer-meta{display:flex;align-items:center;gap:6px;flex-wrap:wrap;margin-top:6px;}' +
      '#CartDrawer .cart-drawer__empty-offer-code{display:inline-flex;align-items:center;height:20px;padding:0 8px;border-radius:999px;border:1px solid #d7dee9;background:#f6f8fb;font-size:9px;font-weight:900;letter-spacing:.025em;text-transform:uppercase;color:#394556;white-space:nowrap;}' +
      '#CartDrawer .cart-drawer__empty-offer-tag{display:none !important;}' +
      '#CartDrawer .cart-drawer__empty-offer-cta{display:flex;flex-direction:column;align-items:flex-end;gap:6px;min-width:150px;padding-top:2px;}' +
      '#CartDrawer .cart-drawer__empty-offer-btn{min-width:96px;height:34px;padding:0 13px;border:0;border-radius:999px;background:var(--cd-ink-solid);color:#fff;font-size:12px;font-weight:900;letter-spacing:.01em;cursor:pointer;white-space:nowrap;transition:transform .14s ease,box-shadow .16s ease,opacity .18s ease;background-image:var(--cd-ink-grad);box-shadow:0 7px 14px rgba(4,10,18,.22);}' +
      '#CartDrawer .cart-drawer__empty-offer-btn:active{transform:scale(.97);}' +
      '#CartDrawer .cart-drawer__empty-offer-btn:hover{opacity:.96;box-shadow:0 10px 22px rgba(0,0,0,.27);}' +
      '#CartDrawer .cart-drawer__empty-offer-save{font-size:9px;font-weight:800;color:#687485;letter-spacing:.02em;text-transform:uppercase;line-height:1.2;white-space:normal;text-align:right;max-width:150px;}' +
      '#CartDrawer .cart-drawer__empty-offer.is-max{border-color:rgba(255,255,255,.14);background:var(--cd-ink-grad);box-shadow:0 12px 26px rgba(1,4,8,.34);}' +
      '#CartDrawer .cart-drawer__empty-offer.is-max::before{background:linear-gradient(180deg,#35d07e,#1fa85b);}' +
      '#CartDrawer .cart-drawer__empty-offer.is-max .cart-drawer__empty-offer-kicker{color:rgba(213,226,244,.75);}' +
      '#CartDrawer .cart-drawer__empty-offer.is-max .cart-drawer__empty-offer-title{color:#f6fbff;}' +
      '#CartDrawer .cart-drawer__empty-offer.is-max .cart-drawer__empty-offer-sub{color:rgba(219,230,246,.82);}' +
      '#CartDrawer .cart-drawer__empty-offer.is-max .cart-drawer__empty-offer-code{border-color:rgba(255,255,255,.24);background:rgba(255,255,255,.1);color:#ebf3ff;}' +
      '#CartDrawer .cart-drawer__empty-offer.is-max .cart-drawer__empty-offer-save{color:rgba(215,227,243,.8);}' +
      '#CartDrawer .cart-drawer__empty-offer.is-max .cart-drawer__empty-offer-btn{background:#ffffff;background-image:none;color:#0b0c0e;border:1px solid rgba(10,12,15,.16);box-shadow:0 10px 20px rgba(4,10,18,.22);}' +
      '#CartDrawer .cart-drawer__empty-offer .cart-drawer__empty-offer-btn{min-width:150px;}' +
      '#CartDrawer .cart-drawer__empty-offer .cart-drawer__empty-offer-title{display:block;}' +
      '#CartDrawer .cart-drawer__empty-offer .cart-drawer__empty-offer-cta{justify-self:end;}' +
      '#CartDrawer .cart-drawer__empty-offer .cart-drawer__empty-offer-kicker{font-size:8.5px;}' +
      '#CartDrawer .cart-drawer__progress-slot{margin:6px 0 8px;}' +
      '#CartDrawer .cart-drawer__goal{position:relative;width:100%;border:1px solid rgba(255,255,255,.13);border-radius:12px;padding:8px 10px 7px;background:linear-gradient(145deg,rgba(21,24,30,.72),rgba(10,12,16,.72));box-shadow:0 10px 24px rgba(0,0,0,.26);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);}' +
      '#CartDrawer button.cart-drawer__goal{appearance:none;-webkit-appearance:none;font:inherit;text-align:left;cursor:pointer;}' +
      '#CartDrawer .cart-drawer__goal.is-clickable{border-color:rgba(69,208,150,.35);}' +
      '#CartDrawer .cart-drawer__goal.is-clickable:hover{border-color:rgba(69,208,150,.58);box-shadow:0 12px 26px rgba(0,0,0,.3);}' +
      '#CartDrawer .cart-drawer__goal.is-clickable:active{transform:scale(.996);}' +
      '#CartDrawer .cart-drawer__goal.is-clickable:focus-visible{outline:2px solid rgba(91,239,178,.55);outline-offset:2px;}' +
      '#CartDrawer .cart-drawer__goal-system{position:relative;}' +
      '#CartDrawer .cart-drawer__goal-track{position:relative;isolation:isolate;height:6px;border-radius:999px;background:rgba(255,255,255,.15);overflow:visible;}' +
      '#CartDrawer .cart-drawer__goal-fill{position:absolute;left:0;top:0;bottom:0;width:0;border-radius:inherit;background:linear-gradient(90deg,#1dbb73,#39d58f);z-index:1;transition:width .45s cubic-bezier(.22,.8,.2,1);}' +
      '#CartDrawer .cart-drawer__goal-milestones{position:absolute;left:0;right:0;top:50%;height:0;transform:translateY(-50%);pointer-events:none;z-index:3;}' +
      '#CartDrawer .cart-drawer__goal-milestone{position:absolute;left:var(--cd-goal-pos);top:0;transform:translate(-50%,-50%);width:17px;height:17px;border-radius:999px;border:1px solid rgba(255,255,255,.2);background:rgba(12,15,20,.9);display:flex;align-items:center;justify-content:center;box-shadow:0 4px 10px rgba(0,0,0,.24);transition:border-color .24s ease,background .24s ease,box-shadow .24s ease;}' +
      '#CartDrawer .cart-drawer__goal-milestone svg{width:11px;height:11px;stroke:rgba(255,255,255,.72);stroke-width:1.8;fill:none;stroke-linecap:round;stroke-linejoin:round;transition:stroke .24s ease;}' +
      '#CartDrawer .cart-drawer__goal-milestone.is-reached{border-color:rgba(56,219,149,.8);background:rgba(25,146,94,.42);box-shadow:0 0 0 3px rgba(44,203,135,.16);}' +
      '#CartDrawer .cart-drawer__goal-milestone.is-reached svg{stroke:rgba(223,255,238,.98);}' +
      '#CartDrawer .cart-drawer__goal-hint{margin:8px 0 0;font-size:11px;line-height:1.2;font-weight:650;letter-spacing:.004em;color:rgba(245,249,255,.86);text-align:center;}' +
      '#CartDrawer .cart-drawer__goal-cta-hint{margin:4px 0 0;font-size:10px;line-height:1.2;font-weight:600;letter-spacing:.004em;color:rgba(233,239,248,.66);text-align:center;}' +
      '#CartDrawer .cart-drawer__goal-reward{color:#31d39d;font-weight:800;}' +
      '@media (max-width: 767px){#CartDrawer .cart-drawer__goal{padding:7px 8px 6px;}#CartDrawer .cart-drawer__goal-track{height:5px;}#CartDrawer .cart-drawer__goal-milestone{width:15px;height:15px;}#CartDrawer .cart-drawer__goal-milestone svg{width:10px;height:10px;}#CartDrawer .cart-drawer__goal-hint{font-size:10.5px;margin-top:7px;}#CartDrawer .cart-drawer__goal-cta-hint{font-size:9.5px;margin-top:3px;}}' +
      '@keyframes cd-empty-offer-in{0%{opacity:0;transform:translateY(6px) scale(.99);}100%{opacity:1;transform:translateY(0) scale(1);}}' +
      /* Offer Découverte line items — styled in cart-drawer.css */
      '';
    document.head.appendChild(style);
  }

  /* [PHASE 5A.1] ensureWarrantyRuntimeStyles supprimé — code warranty supprimé. */

  function getDom() {
    var drawer = qs(SEL.drawer);
    if (!drawer) return null;

    if (DOM && DOM.drawer === drawer) return DOM;

    DOM = {
      drawer: drawer,
      itemsWrap: qs(SEL.itemsWrap, drawer),
      upsellCard: ensureUpsellCard(drawer),
      /* [PHASE 5A.1] warrantySlot: on garde une ref au slot s'il existe déjà dans le Liquid,
         mais on ne le crée plus côté JS. Utilisé uniquement pour le hide propre sur empty. */
      warrantySlot: qs(SEL.warrantySlot, drawer),
      progressSlot: ensureProgressSlot(drawer),
      savings: ensureSavingsSlot(drawer),
      empty: qs(SEL.empty, drawer),
      subtotal: qs(SEL.subtotal, drawer),
      tpl: qs(SEL.itemTpl, drawer),
      discountMsg: qs(SEL.discountMsg, drawer),
      upsellNoticeEl: qs('#CartDrawerUpsellNotice', drawer),
      checkoutBtn: qs('#CartDrawerCheckout', drawer),

      overlay: qs(SEL.overlay, drawer),
      closeBtn: qs(SEL.closeBtn, drawer),

      discountWrap: qs(SEL.discountWrap, drawer),
      discountToggle: qs(SEL.discountToggle, drawer),
      discountBtn: qs(SEL.discountBtn, drawer),
      discountInput: qs(SEL.discountInput, drawer)
    };
    ensureDrawerMarketingRuntimeStyles();

    return DOM;
  }

  function renderEmptyDrawerMarketing(emptyEl) {
    if (!emptyEl) return;
    emptyEl.innerHTML =
      '<div class="cart-drawer__empty-shell">' +
      '<div class="cart-drawer__empty-hero">' +
        '<h4 class="cart-drawer__empty-title">Ton prochain maillot t\u2019attend</h4>' +
        '<p class="cart-drawer__empty-sub">Active ton offre maintenant pour débloquer le meilleur prix sur ta commande.</p>' +
      '</div>' +
      '<div class="cart-drawer__empty-offers">' +
        '<article class="cart-drawer__empty-offer is-max">' +
          '<div class="cart-drawer__empty-offer-main">' +
            '<p class="cart-drawer__empty-offer-kicker">Offre volume 5 maillots</p>' +
            '<p class="cart-drawer__empty-offer-title">-21,99 €</p>' +
            '<p class="cart-drawer__empty-offer-sub">Ton meilleur palier de réduction.</p>' +
          '</div>' +
          '<div class="cart-drawer__empty-offer-cta">' +
            '<button type="button" class="cart-drawer__empty-offer-btn" data-empty-offer-code="' + escapeHtml(EMPTY_PROMO_CODE_5) + '">Activer -21,99€</button>' +
            '<span class="cart-drawer__empty-offer-save">Valable à partir de 5 maillots</span>' +
          '</div>' +
        '</article>' +
        '<article class="cart-drawer__empty-offer">' +
          '<div class="cart-drawer__empty-offer-main">' +
            '<p class="cart-drawer__empty-offer-kicker">Offre volume 4 maillots</p>' +
            '<p class="cart-drawer__empty-offer-title">-15 €</p>' +
            '<p class="cart-drawer__empty-offer-sub">Soit quasiment un maillot offert.</p>' +
          '</div>' +
          '<div class="cart-drawer__empty-offer-cta">' +
            '<button type="button" class="cart-drawer__empty-offer-btn" data-empty-offer-code="' + escapeHtml(EMPTY_PROMO_CODE_4) + '">Activer -15€</button>' +
            '<span class="cart-drawer__empty-offer-save">Valable à partir de 4 maillots</span>' +
          '</div>' +
        '</article>' +
      '</div>' +
      '</div>';
  }

  function getActiveDiscountCodesUpper(cart) {
    var out = {};
    if (!cart || !Array.isArray(cart.discount_codes)) return out;
    for (var i = 0; i < cart.discount_codes.length; i++) {
      var code = String((cart.discount_codes[i] && cart.discount_codes[i].code) || '').trim().toUpperCase();
      if (!code) continue;
      out[code] = true;
    }
    return out;
  }

  function getDrawerActivableStep(count) {
    var safe = parseInt(count, 10) || 0;
    if (safe >= 9) return 9;
    if (safe >= 5) return 5;
    if (safe >= 2 && safe <= 4) return safe;
    return null;
  }

  function getDrawerOfferByStep(step) {
    var safe = parseInt(step, 10) || 0;
    if (!safe) return null;
    return DRAWER_PROMO_OFFER_BY_STEP[safe] || null;
  }

  function renderCartGoalProgress(slotEl, cart) {
    if (!slotEl) return;
    var totalCount = parseInt((cart && cart.item_count) || 0, 10) || 0;
    if (!totalCount) {
      slotEl.style.display = 'none';
      slotEl.innerHTML = '';
      return;
    }

    /* [ANNOTATION | DATE: 2026-04-05]
       WHY: l'offre découverte est EXCLUSIVE — elle ne marche que si le panier ne contient
       QUE des items offre. Dès qu'un maillot normal est ajouté, l'offre saute et TOUS
       les items (y compris offre) comptent dans les paliers volume normalement.
       IMPACT: pas de double avantage possible. */
    var offerItemCount = 0;
    var normalItemCount = 0;
    if (cart && cart.items) {
      for (var oi = 0; oi < cart.items.length; oi++) {
        if (cart.items[oi].properties && cart.items[oi].properties._offer === 'decouverte') {
          offerItemCount += cart.items[oi].quantity;
        } else {
          normalItemCount += cart.items[oi].quantity;
        }
      }
    }
    /* [ANNOTATION | DATE: 2026-04-05]
       WHY: le bandeau "Offre Découverte activée" ne doit s'afficher QUE si :
       1) la composition est bonne (>= 2 items offre, 0 items normaux)
       2) ET le code discount est réellement appliqué dans cart.discount_codes
       Sinon le client voit "offre activée" alors que le prix n'est pas réduit.
       IMPACT: pas de bandeau trompeur quand le discount n'est pas encore/plus appliqué. */
    var _pdk = [57,75,65,87,84,72,81,80,49,83,68,65];
    var _pdc = _pdk.map(function(c){ return String.fromCharCode(c); }).join('');
    var _pdc4 = '05CRANPQ3ED8';
    var offerCodeApplied = false;
    if (cart && cart.discount_codes) {
      for (var dk = 0; dk < cart.discount_codes.length; dk++) {
        if (cart.discount_codes[dk].code === _pdc || cart.discount_codes[dk].code === _pdc4) { offerCodeApplied = true; break; }
      }
    }
    var _pOfferType = '2';
    try { _pOfferType = sessionStorage.getItem('covred_offer_type') || '2'; } catch(ex){}
    var _pReqQty = _pOfferType === '4' ? 4 : 2;
    var offerExclusive = offerItemCount >= _pReqQty && normalItemCount === 0 && offerCodeApplied;

    if (offerExclusive) {
      var _pMsg = _pOfferType === '4' ? '4 maillots pour 39,99\u20ac' : '2 maillots pour 27,99\u20ac';
      slotEl.innerHTML =
        '<div class="cart-drawer__goal">' +
          '<div class="cart-drawer__goal-system">' +
            '<div class="cart-drawer__goal-track"><div class="cart-drawer__goal-fill" style="width:100%;background:#31d39d;"></div></div>' +
          '</div>' +
          '<p class="cart-drawer__goal-hint"><span style="color:#31d39d;font-weight:700;">\u2713 Offre D\u00e9couverte activ\u00e9e</span> \u2014 ' + _pMsg + '</p>' +
        '</div>';
      slotEl.style.display = '';
      return;
    }

    /* Sinon : tous les items comptent dans les paliers volume */
    var count = totalCount;
    var clamp = Math.max(0, Math.min(9, count));
    var progress = Math.max(0, Math.min(100, (clamp / 9) * 100));
    /* [FIX 2026-04-04] Messages clairs : offre dispo = on le dit + code, sinon incite vers le prochain palier */
    var _pc2 = (window.COVRED && window.COVRED.promoCodes) || {};
    var CODES = { 2: _pc2.step2 || 'COVRED24', 3: _pc2.step3 || 'COVREDGOAT', 4: _pc2.step4 || 'GAKNHT85SRVA', 5: _pc2.step5 || '8PY09B7JER1K', 9: _pc2.step9 || 'COVREDBONITO' };
    var REWARDS = { 2: '-10%', 3: '-15%', 4: '-15\u20ac', 5: '1 maillot offert', 9: '-50\u20ac' };
    var STEPS = [2, 3, 4, 5, 9];
    var currentStep = 0;
    var nextStep = 0;
    for (var si = STEPS.length - 1; si >= 0; si--) { if (count >= STEPS[si]) { currentStep = STEPS[si]; break; } }
    for (var sj = 0; sj < STEPS.length; sj++) { if (count < STEPS[sj]) { nextStep = STEPS[sj]; break; } }

    var message = '';
    if (currentStep && nextStep) {
      var cdRemaining = nextStep - count;
      var cdNext = cdRemaining > 1
        ? (cdRemaining + ' maillots pour <span class="cart-drawer__goal-reward">' + REWARDS[nextStep] + '</span>')
        : ('1 maillot pour <span class="cart-drawer__goal-reward">' + REWARDS[nextStep] + '</span>');
      message = '\ud83c\udf81 <span class="cart-drawer__goal-reward">' + REWARDS[currentStep] + '</span> dispo \u2014 code : <strong>' + CODES[currentStep] + '</strong> \u2014 encore ' + cdNext;
    } else if (currentStep && !nextStep) {
      message = '\ud83c\udf81 Offre max <span class="cart-drawer__goal-reward">' + REWARDS[currentStep] + '</span> \u2014 code : <strong>' + CODES[currentStep] + '</strong>';
    } else if (count === 1) {
      message = '+1 maillot = <span class="cart-drawer__goal-reward">-10%</span> \u00b7 +2 = <span class="cart-drawer__goal-reward">-15%</span>';
    } else {
      message = '2 maillots = <span class="cart-drawer__goal-reward">-10%</span> \u00b7 3 maillots = <span class="cart-drawer__goal-reward">-15%</span>';
    }

    var activableStep = getDrawerActivableStep(count);
    var activableOffer = getDrawerOfferByStep(activableStep);
    var isClickable = !!(activableOffer && activableOffer.code);
    var goalTag = isClickable ? 'button' : 'div';
    var goalAttrs = isClickable
      ? (' type="button" class="cart-drawer__goal is-clickable" data-empty-offer-code="' + escapeHtml(activableOffer.code) + '" aria-label="Activer l\u2019offre disponible"')
      : ' class="cart-drawer__goal"';
    var ctaHintHtml = isClickable
      ? '<p class="cart-drawer__goal-cta-hint">Appuyez sur la barre pour activer l\u2019offre disponible</p>'
      : '';

    slotEl.innerHTML =
      '<' + goalTag + goalAttrs + '>' +
        '<div class="cart-drawer__goal-system">' +
          '<div class="cart-drawer__goal-track">' +
            '<div class="cart-drawer__goal-fill" style="width:' + progress + '%"></div>' +
            '<span class="cart-drawer__goal-milestones" aria-hidden="true">' +
              '<span class="cart-drawer__goal-milestone" data-step="2" style="--cd-goal-pos:22.22%;">' +
                '<svg viewBox="0 0 24 24" focusable="false"><path d="M3.5 8.5h17v4h-17z"></path><path d="M5 12.5h14v8h-14z"></path><path d="M12 8.5v12"></path><path d="M12 8.5h4a2.1 2.1 0 1 0-1.9-3c-.6 1.2-2.1 3-2.1 3Zm0 0H8a2.1 2.1 0 1 1 1.9-3c.6 1.2 2.1 3 2.1 3Z"></path></svg>' +
              '</span>' +
              '<span class="cart-drawer__goal-milestone" data-step="3" style="--cd-goal-pos:33.33%;">' +
                '<svg viewBox="0 0 24 24" focusable="false"><path d="M3.5 8.5h17v4h-17z"></path><path d="M5 12.5h14v8h-14z"></path><path d="M12 8.5v12"></path><path d="M12 8.5h4a2.1 2.1 0 1 0-1.9-3c-.6 1.2-2.1 3-2.1 3Zm0 0H8a2.1 2.1 0 1 1 1.9-3c.6 1.2 2.1 3 2.1 3Z"></path></svg>' +
              '</span>' +
              '<span class="cart-drawer__goal-milestone" data-step="4" style="--cd-goal-pos:44.44%;">' +
                '<svg viewBox="0 0 24 24" focusable="false"><path d="M3.5 8.5h17v4h-17z"></path><path d="M5 12.5h14v8h-14z"></path><path d="M12 8.5v12"></path><path d="M12 8.5h4a2.1 2.1 0 1 0-1.9-3c-.6 1.2-2.1 3-2.1 3Zm0 0H8a2.1 2.1 0 1 1 1.9-3c.6 1.2 2.1 3 2.1 3Z"></path></svg>' +
              '</span>' +
              '<span class="cart-drawer__goal-milestone" data-step="5" style="--cd-goal-pos:55.55%;">' +
                '<svg viewBox="0 0 24 24" focusable="false"><path d="M3.5 8.5h17v4h-17z"></path><path d="M5 12.5h14v8h-14z"></path><path d="M12 8.5v12"></path><path d="M12 8.5h4a2.1 2.1 0 1 0-1.9-3c-.6 1.2-2.1 3-2.1 3Zm0 0H8a2.1 2.1 0 1 1 1.9-3c.6 1.2 2.1 3 2.1 3Z"></path></svg>' +
              '</span>' +
              '<span class="cart-drawer__goal-milestone" data-step="9" style="--cd-goal-pos:100%;">' +
                '<svg viewBox="0 0 24 24" focusable="false"><path d="M3.5 8.5h17v4h-17z"></path><path d="M5 12.5h14v8h-14z"></path><path d="M12 8.5v12"></path><path d="M12 8.5h4a2.1 2.1 0 1 0-1.9-3c-.6 1.2-2.1 3-2.1 3Zm0 0H8a2.1 2.1 0 1 1 1.9-3c.6 1.2 2.1 3 2.1 3Z"></path></svg>' +
              '</span>' +
            '</span>' +
          '</div>' +
        '</div>' +
        '<p class="cart-drawer__goal-hint">' + message + '</p>' +
        ctaHintHtml +
      '</' + goalTag + '>';

    var fillEl = slotEl.querySelector('.cart-drawer__goal-fill');
    var milestoneEls = slotEl.querySelectorAll('.cart-drawer__goal-milestone[data-step]');
    for (var ms = 0; ms < milestoneEls.length; ms++) {
      var msStep = parseInt(milestoneEls[ms].getAttribute('data-step') || '0', 10) || 0;
      milestoneEls[ms].classList.toggle('is-reached', count >= msStep);
    }
    var hasAnimatedForThisOpen = String(slotEl.getAttribute('data-goal-anim-open') || '') === String(drawerOpenSequence);
    if (fillEl) {
      if (!hasAnimatedForThisOpen) {
        fillEl.style.transition = 'none';
        fillEl.style.width = '0%';
        requestAnimationFrame(function () {
          fillEl.style.transition = 'width .7s cubic-bezier(.22,.8,.2,1)';
          fillEl.style.width = progress + '%';
        });
        slotEl.setAttribute('data-goal-anim-open', String(drawerOpenSequence));
      } else {
        fillEl.style.transition = 'none';
        fillEl.style.width = progress + '%';
      }
    }
    slotEl.style.display = '';
  }

  function safeReplaceChildren(el, frag) {
    if (!el) return;
    if (typeof el.replaceChildren === 'function') {
      el.replaceChildren(frag);
    } else {
      el.textContent = '';
      el.appendChild(frag);
    }
  }


  /* Money, string, and pure utility functions moved to cart-drawer-money.js */
  /* Access via window.COVRED.money.format(), .toCents(), .escapeHtml(), etc. */
  var escapeHtml = function(t) { return COVRED.money.escapeHtml(t); };
  var formatMoney = function(c) { return COVRED.money.format(c); };
  var formatMoneyEuroSuffix = function(c) { return COVRED.money.formatEuroSuffix(c); };
  var formatFrDecimal = function(v,d) { return COVRED.money.formatFrDecimal(v,d); };
  var moneyStringToCents = function(v) { return COVRED.money.toCents(v); };
  var extractExtraCents = function(t) { return COVRED.money.extractExtraCents(t); };
  var stripAddonPrices = function(t) { return COVRED.money.stripAddonPrices(t); };
  var countFlocageProperties = function(i) { return COVRED.money.countFlocage(i); };
  var splitTitleAtDash = function(t) { return COVRED.money.splitTitle(t); };
  var normalizeSimple = function(v) { return COVRED.money.normalizeSimple(v); };
  var animateSubtotalCounter = function(e,t,o) { return COVRED.money.animateSubtotal(e,t,o); };
  var setSubtotalHtml = function(e,c,o) { return COVRED.money.setSubtotalHtml(e,c,o); };
  var sanitizeLegacyOfferDetails = function(d) { return COVRED.money.sanitizeLegacyOfferDetails(d); };
  var setFlocLineContent = function(e,t) { return COVRED.money.setFlocLineContent(e,t); };
  var FLOCAGE_UNIT_CENTS = COVRED.money.FLOCAGE_UNIT_CENTS;
  var RE_FLOCAGE_KEY = COVRED.money.RE_FLOCAGE_KEY;

  // -------------------------
  // Fetch helpers (plus rapides et cohérents)
  // -------------------------
  function fetchJSON(url, options) {
    return fetch(url, options).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (err) {
          var msg = (err && (err.description || err.message)) ? (err.description || err.message) : ('HTTP ' + res.status);
          throw new Error(msg);
        });
      }
      return res.json();
    });
  }

  function fetchCart(signal) {
    return fetchJSON('/cart.js', {
      credentials: 'same-origin',
      signal: signal
    });
  }

  function setUpsellSessionActive(active) {
    try {
      sessionStorage.setItem(UPSELL_SESSION_KEY, active ? '1' : '0');
    } catch (e) {}
  }

  function isUpsellSessionActive() {
    try {
      return sessionStorage.getItem(UPSELL_SESSION_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function markUpsellJustAdded() {
    try {
      sessionStorage.setItem(UPSELL_JUST_ADDED_UNTIL_KEY, String(Date.now() + UPSELL_JUST_ADDED_WINDOW_MS));
    } catch (e) {}
  }

  function consumeUpsellJustAddedMarker() {
    try {
      var raw = sessionStorage.getItem(UPSELL_JUST_ADDED_UNTIL_KEY);
      sessionStorage.removeItem(UPSELL_JUST_ADDED_UNTIL_KEY);
      if (!raw) return false;
      var untilTs = parseInt(raw, 10);
      return !!(untilTs && untilTs > Date.now());
    } catch (e) {
      return false;
    }
  }

  function isUpsellInvalidNoticeShown() {
    try {
      return sessionStorage.getItem(UPSELL_INVALID_NOTICE_SHOWN_KEY) === '1';
    } catch (e) {
      return false;
    }
  }

  function setUpsellInvalidNoticeShown(shown) {
    try {
      sessionStorage.setItem(UPSELL_INVALID_NOTICE_SHOWN_KEY, shown ? '1' : '0');
    } catch (e) {}
  }


  function addToCartViaAjax(form) {
    var formData = new FormData(form);

    return fetchJSON('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
  }

  // IMPORTANT: /cart/change.js renvoie le cart en JSON -> on l'utilise directement (gros gain perf)
  function changeCartLine(id, quantity) {
    return fetchJSON('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ id: id, quantity: quantity })
    });
  }

  var productsPagePromiseCache = {};
  function fetchProductsPage(page) {
    var pageNo = String(page || 1);
    if (productsPagePromiseCache[pageNo]) return productsPagePromiseCache[pageNo];

    productsPagePromiseCache[pageNo] = fetchJSON('/products.json?limit=250&page=' + pageNo, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (data) {
      return data && Array.isArray(data.products) ? data.products : [];
    }).catch(function () {
      return [];
    });
    return productsPagePromiseCache[pageNo];
  }

  function fetchProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    return fetchJSON('/products/' + encodeURIComponent(String(handle)) + '.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).catch(function () {
      return null;
    });
  }

  var preloadedUpsellImageByUrl = {};
  function preloadUpsellImage(url) {
    var src = String(url || '').trim();
    if (!src) return;
    if (preloadedUpsellImageByUrl[src]) return;
    preloadedUpsellImageByUrl[src] = 1;

    try {
      var img = new Image();
      try { img.decoding = 'async'; } catch (e) {}
      try { img.fetchPriority = 'low'; } catch (e) {}
      img.src = src;
    } catch (e) {}
  }

  function pickNeutralVariantForOffer(products, wantedSize) {
    if (!Array.isArray(products)) return 0;
    var preferred = 0;
    var fallback = 0;
    var hasWanted = !!String(wantedSize || '').trim();

    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      if (!p || !Array.isArray(p.variants)) continue;
      var rank = 2;
      var token = normalizeSimple((p.title || '') + ' ' + (p.handle || ''));
      if (token.indexOf('upsell') >= 0 || token.indexOf('neutre') >= 0 || token.indexOf('neutral') >= 0 || token.indexOf('addon') >= 0 || token.indexOf('carrier') >= 0 || token.indexOf('offre') >= 0 || token.indexOf('special') >= 0 || token.indexOf('speciale') >= 0) {
        rank = 1;
      }

      for (var j = 0; j < p.variants.length; j++) {
        var v = p.variants[j];
        if (!v || !v.available) continue;
        if (hasWanted && !variantMatchesSize(v, wantedSize)) continue;
        var id = parseInt(v.id, 10) || 0;
        if (!id) continue;
        if (rank === 1 && !preferred) preferred = id;
        if (!fallback) fallback = id;
      }
    }

    return preferred || fallback || 0;
  }

  function resolveNeutralVariantForOffer(wantedSize) {
    // [ANNOTATION | DATE: 2026-02-15]
    // WHY: le bouton upsell doit ajouter un VRAI line item Shopify (peu importe son prix catalogue),
    // puis la remise -8€ sera appliquee au moment du checkout via /discount/UPSELL.
    // DO NOT CHANGE: ne jamais simuler une ligne fictive front-only.
    // IMPACT: le checkout reste synchro avec Shopify.
    var cfg = window.COVRED_NEUTRAL_ADDON;
    if (cfg && cfg.enabled && cfg.variantId && !wantedSize) {
      return Promise.resolve(parseInt(cfg.variantId, 10) || 0);
    }

    var cacheKey = wantedSize ? ('covred_neutral_offer_variant_id_' + String(wantedSize).toLowerCase()) : 'covred_neutral_offer_variant_id';
    try {
      var cached = parseInt(sessionStorage.getItem(cacheKey) || '0', 10);
      if (cached) return Promise.resolve(cached);
    } catch (e) {}

    var maxPages = 8; // 2000 produits max
    var chain = Promise.resolve(0);
    for (var p = 1; p <= maxPages; p++) {
      (function (pageNo) {
        chain = chain.then(function (found) {
          if (found) return found;
            return fetchProductsPage(pageNo).then(function (products) {
            return pickNeutralVariantForOffer(products, wantedSize);
          });
        });
      })(p);
    }

    return chain.then(function (id) {
      var vId = parseInt(id, 10) || 0;
      if (vId) {
        try { sessionStorage.setItem(cacheKey, String(vId)); } catch (e) {}
      }
      return vId;
    });
  }

  function normalizeSizeCompact(v) {
    return String(v || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function getSizeAliases(wantedSize) {
    var s = String(wantedSize || '').toUpperCase().trim();
    if (s === 'S') return ['S', 'SMALL', 'PETIT'];
    if (s === 'M') return ['M', 'MEDIUM', 'MOYEN'];
    if (s === 'L') return ['L', 'LARGE', 'GRAND'];
    if (s === 'XL') return ['XL', 'X-L', 'X LARGE', 'EXTRA LARGE', 'EXTRALARGE', 'XLARGE'];
    if (s === '2XL') return ['2XL', 'XXL', '2X-L', '2 X LARGE', 'DOUBLE XL', 'DOUBLEXL', '2XLARGE'];
    return [s];
  }

  function variantFieldHasSize(raw, wantedSize) {
    var source = String(raw || '').toUpperCase();
    var compact = normalizeSizeCompact(raw);
    var aliases = getSizeAliases(wantedSize);
    if (!source || !aliases.length) return false;

    var tokens = source
      .replace(/[^A-Z0-9]+/g, ' ')
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    for (var i = 0; i < aliases.length; i++) {
      var alias = aliases[i];
      var aliasCompact = normalizeSizeCompact(alias);
      if (!aliasCompact) continue;

      // 1) match par token exact (évite L qui match XL)
      for (var j = 0; j < tokens.length; j++) {
        if (tokens[j] === alias) return true;
      }

      // 2) match compact pour formes comme "xlarge", "taillexl", "2xlarge"
      if (aliasCompact.length >= 2 && compact.indexOf(aliasCompact) >= 0) return true;
    }
    return false;
  }

  function variantMatchesSize(variant, wantedSize) {
    if (!variant || !wantedSize) return false;
    if (variantFieldHasSize(variant.option1, wantedSize)) return true;
    if (variantFieldHasSize(variant.option2, wantedSize)) return true;
    if (variantFieldHasSize(variant.option3, wantedSize)) return true;
    if (variantFieldHasSize(variant.title, wantedSize)) return true;
    return false;
  }

  function resolveNeutralVariantForSize(size, sourceProduct) {
    var cfg = window.COVRED_NEUTRAL_ADDON || {};
    var wanted = String(size || '').trim();

    function findVariantIdInList(list, targetSize) {
      if (!Array.isArray(list) || !targetSize) return 0;
      for (var i = 0; i < list.length; i++) {
        var v = list[i];
        if (!v) continue;
        if (v.available === false) continue;
        if (!variantMatchesSize(v, targetSize)) continue;
        var id = parseInt(v.id, 10) || 0;
        if (id) return id;
      }
      return 0;
    }

    if (wanted && sourceProduct) {
      var sourceMatch = findVariantIdInList(sourceProduct.variants, wanted);
      if (sourceMatch) return Promise.resolve(sourceMatch);

      if (sourceProduct.handle) {
        return fetchProductByHandle(sourceProduct.handle).then(function (product) {
          var sourceDynamic = findVariantIdInList(product && product.variants, wanted);
          if (sourceDynamic) return sourceDynamic;
          throw new Error('Taille ' + wanted + ' indisponible pour cette offre.');
        });
      }

      return Promise.reject(new Error('Taille ' + wanted + ' indisponible pour cette offre.'));
    }

    if (wanted) {
      var staticMatch = findVariantIdInList(cfg.variants, wanted);
      if (staticMatch) return Promise.resolve(staticMatch);

      // [ANNOTATION | DATE: 2026-02-15]
      // WHY: certains thèmes injectent des variantes incomplètes côté Liquid.
      // On recharge le produit live pour trouver la vraie variante taille.
      // IMPACT: évite l'ajout en S quand l'utilisateur choisit L/XL.
      if (cfg.handle) {
        return fetchProductByHandle(cfg.handle).then(function (product) {
          var dynamicMatch = findVariantIdInList(product && product.variants, wanted);
          if (dynamicMatch) return dynamicMatch;
          // Si produit configuré sans match taille, on tente un scan auto de secours.
          return resolveNeutralVariantForOffer(wanted).then(function (scanId) {
            if (scanId) return scanId;
            throw new Error('Taille ' + wanted + ' indisponible pour cette offre.');
          });
        });
      }

      return resolveNeutralVariantForOffer(wanted).then(function (scanId) {
        if (scanId) return scanId;
        throw new Error('Taille ' + wanted + ' indisponible pour cette offre.');
      });
    }

    // Fallback legacy: garde le comportement actuel si mapping taille indisponible.
    return resolveNeutralVariantForOffer();
  }

  /* [PHASE 5A.1] Helpers warranty (isWarrantyVariantId, getWarrantyOptionByVariantId,
     getWarrantyLineItem, getWarrantyTargetKey, parseWarrantyTargetMapFromProps,
     parseWarrantyTargetSignatureMapFromProps, getWarrantyLineItems, getWarrantyTargetState,
     getWarrantyCoveredCount) supprimés — code mort. */

  function isUpsellLineItem(item) {
    if (!item || !item.properties) return false;
    if (String(item.properties._covred_upsell_offer || '') === '1') return true;
    if (String(item.properties._covred_neutral_addon || '') === '1199') return true;
    return false;
  }

  function cartHasUpsellLine(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (isUpsellLineItem(it)) return true;
    }
    return false;
  }

  /* [PHASE 5A.1] Helpers warranty (buildWarrantyTargetSignature, getVisibleItemProperties,
     compactWord, stripMoneyTokens, sanitizeFlocValue, getWarrantyTargetFirstWordTitle,
     getWarrantyTargetFlocageShort, getWarrantyTargetSizeShort, buildWarrantyTargetCheckoutLabel,
     formatWarrantyCheckoutSummary, buildWarrantyCheckoutProperties) supprimés — code mort. */

  function getNonWarrantyItemCount(cart) {
    /* [PHASE 5A.1] Warranty supprimé, plus rien à filtrer.
       Renommer en getCartItemCount serait plus propre mais on garde
       le nom pour rétrocompat avec shouldKeepUpsellCode. */
    return (cart && cart.items) ? cart.items.length : 0;
  }

  function getPrimaryCartItemForUpsell(cart) {
    /* [PHASE 5A.1] Warranty supprimé — plus de filtre warranty, on retourne le premier
       item non-upsell, ou le premier item si tout est upsell. */
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return null;
    var first = null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (!it) continue;
      if (!first) first = it;
      if (!isUpsellLineItem(it)) return it;
    }
    return first;
  }

  function buildDiscountRedirectUrl(code, redirectPath) {
    var c = encodeURIComponent(code || '');
    var r = encodeURIComponent(redirectPath || '/cart');
    return '/discount/' + c + '?redirect=' + r;
  }

  function isUpsellDiscountActiveOnCart(cart) {
    if (!cart) return false;

    var hasCode = !!(Array.isArray(cart.discount_codes) && cart.discount_codes.some(function (d) {
      return d && String(d.code || '').toUpperCase() === String(UPSELL_DISCOUNT_CODE).toUpperCase();
    }));

    var totalDiscount = Number(cart.total_discount || 0);
    var hasEffectiveDiscount = totalDiscount > 0;

    // [ANNOTATION | DATE: 2026-02-15]
    // WHY: si le code existe mais n'est plus eligible (ex: minimum 2 maillots non respecte),
    // Shopify ne doit plus afficher la ligne upsell a 11,99€ dans le drawer.
    // IMPACT: affichage drawer toujours coherent avec le checkout reel.
    return hasCode && hasEffectiveDiscount;
  }

  function canOfferUpsell(cart) {
    if (!cart) return false;
    var count = getNonWarrantyItemCount(cart);
    // [ANNOTATION | DATE: 2026-02-15]
    // WHY: l'upsell ne doit etre propose que quand il y a exactement 1 article "maillot".
    // La garantie Covred+ ne doit pas impacter cette règle.
    // IMPACT: si panier >= 2 maillots, le bouton upsell disparait; la garantie n'interfere pas.
    return count === 1 && !cartHasUpsellLine(cart);
  }

  function getSelectedUpsellSize() {
    try {
      return sessionStorage.getItem(UPSELL_SIZE_KEY) || 'S';
    } catch (e) {
      return 'S';
    }
  }

  function setSelectedUpsellSize(size) {
    try {
      sessionStorage.setItem(UPSELL_SIZE_KEY, size || 'S');
    } catch (e) {}
  }

  function getUpsellABVariant() {
    try {
      var saved = sessionStorage.getItem(UPSELL_AB_KEY);
      if (saved === 'a' || saved === 'b') return saved;
      var next = Math.random() < 0.5 ? 'a' : 'b';
      sessionStorage.setItem(UPSELL_AB_KEY, next);
      return next;
    } catch (e) {
      return 'a';
    }
  }

  function extractBaseSizeFromCartItem(item) {
    if (!item) return '';
    var candidates = [
      item.variant_title,
      item.variant_options && item.variant_options[0],
      item.options_with_values && item.options_with_values[0] && item.options_with_values[0].value
    ];
    var allowed = { S: 1, M: 1, L: 1, XL: 1, '2XL': 1 };

    for (var i = 0; i < candidates.length; i++) {
      var raw = String(candidates[i] || '').toUpperCase();
      if (!raw) continue;
      var tokens = raw.replace(/[^A-Z0-9]+/g, ' ').trim().split(/\s+/);
      for (var j = 0; j < tokens.length; j++) {
        var t = tokens[j];
        if (allowed[t]) return t;
        if (t === 'XXL') return '2XL';
      }
      if (raw.indexOf('X LARGE') >= 0 || raw.indexOf('XLARGE') >= 0) return 'XL';
    }
    return '';
  }

  function getUpsellDeadlineMs() {
    try {
      var raw = parseInt(sessionStorage.getItem(UPSELL_TIMER_KEY) || '0', 10);
      return isFinite(raw) ? raw : 0;
    } catch (e) {
      return 0;
    }
  }

  function ensureUpsellDeadlineMs() {
    try {
      if (sessionStorage.getItem(UPSELL_TIMER_EXPIRED_KEY) === '1') return 0;
    } catch (e) {}

    var now = Date.now();
    var current = getUpsellDeadlineMs();
    if (current > now) return current;
    var next = now + (5 * 60 * 1000);
    try {
      sessionStorage.setItem(UPSELL_TIMER_KEY, String(next));
      sessionStorage.removeItem(UPSELL_TIMER_EXPIRED_KEY);
    } catch (e) {}
    return next;
  }

  function clearUpsellDeadlineMs() {
    try {
      sessionStorage.removeItem(UPSELL_TIMER_KEY);
      sessionStorage.removeItem(UPSELL_TIMER_EXPIRED_KEY);
    } catch (e) {}
  }

  function formatCountdown(msLeft) {
    var total = Math.max(0, Math.floor(msLeft / 1000));
    var m = Math.floor(total / 60);
    var s = total % 60;
    return (m < 10 ? '0' + m : String(m)) + ':' + (s < 10 ? '0' + s : String(s));
  }

  function renderUpsellCard(cardEl, cart) {
    if (!cardEl) return;

    if (!canOfferUpsell(cart)) {
      stopUpsellCardTimer();
      clearUpsellDeadlineMs();
      cardEl.style.display = 'none';
      cardEl.innerHTML = '';
      return;
    }

    var fallbackItem = getPrimaryCartItemForUpsell(cart);
    var baseHandle = getItemHandle(fallbackItem);
    var clubToken = clubTokenFromTitle((fallbackItem && (fallbackItem.product_title || fallbackItem.title)) || '');
    var noSuggestionKnown = false;
    if (clubToken) {
      if (upsellNoSuggestionByClubToken[clubToken]) noSuggestionKnown = true;
      if (fallbackItem && fallbackItem.key && upsellNoSuggestionByBaseKey[String(fallbackItem.key)]) noSuggestionKnown = true;
    }

    var suggestedProduct = getActiveUpsellSuggestion();
    var suggestedCount = Array.isArray(currentUpsellSuggestions) ? currentUpsellSuggestions.length : 0;
    if (suggestedProduct && baseHandle) {
      var suggestedHandle = String(suggestedProduct.handle || '').trim();
      if (suggestedHandle && suggestedHandle === baseHandle) suggestedProduct = null;
    }
    if (suggestedProduct && clubToken && !productMatchesClub(suggestedProduct, clubToken, baseHandle)) {
      suggestedProduct = null;
    }

    var title = '';
    var image = '';
    if (suggestedProduct) {
      title = String(suggestedProduct.title || '').trim();
      image = productImageUrl(suggestedProduct);
    }

    var shouldShowLoadingState = !title && !noSuggestionKnown;
    var normalPrice = formatMoneyEuroSuffix(1999);
    var specialPrice = formatMoneyEuroSuffix(1199);
    var sizes = ['S', 'M', 'L', 'XL', '2XL'];
    var selectedSize = getSelectedUpsellSize();
    var suggested = extractBaseSizeFromCartItem(fallbackItem);
    if (suggested) {
      selectedSize = suggested;
      setSelectedUpsellSize(suggested);
    }
    var chips = '';
    for (var i = 0; i < sizes.length; i++) {
      var size = sizes[i];
      chips += '<button type="button" class="cart-drawer__upsell-size-btn' + (size === selectedSize ? ' is-active' : '') + '" data-upsell-size="' + size + '">' + size + '</button>';
    }

    ensureUpsellDeadlineMs();
    var deadline = getUpsellDeadlineMs();
    var timerText = formatCountdown(deadline > 0 ? (deadline - Date.now()) : 0);
    var isExpiredNow = false;
    try { isExpiredNow = sessionStorage.getItem(UPSELL_TIMER_EXPIRED_KEY) === '1'; } catch (e) {}

    if (shouldShowLoadingState) {
      cardEl.innerHTML =
        '<div class="cart-drawer__upsell-top">' +
          '<div class="cart-drawer__upsell-head">OFFRE FLASH : 2E MAILLOT À 11,99€</div>' +
          '<div class="cart-drawer__upsell-timer"><span data-upsell-timer>' + timerText + '</span></div>' +
        '</div>' +
        '<div class="cart-drawer__upsell-loading">' +
          '<span class="cart-drawer__upsell-loading-dot"></span>' +
          '<span>Préparation de ton offre du même club…</span>' +
        '</div>';
      cardEl.classList.remove('cart-drawer__upsell-card--ab-a', 'cart-drawer__upsell-card--ab-b', 'is-last-chance');
      cardEl.classList.add(getUpsellABVariant() === 'b' ? 'cart-drawer__upsell-card--ab-b' : 'cart-drawer__upsell-card--ab-a', 'is-searching');
      if (isExpiredNow) cardEl.classList.add('is-last-chance');
      cardEl.style.display = '';
      startUpsellCardTimer(cardEl);
      return;
    }

    if (!title) {
      // [ANNOTATION | DATE: 2026-02-16]
      // WHY: ne jamais afficher le même maillot que celui déjà dans le panier pendant la recherche.
      // IMPACT: on masque l'upsell si aucune suggestion valide n'est disponible.
      stopUpsellCardTimer();
      cardEl.style.display = 'none';
      cardEl.innerHTML = '';
      return;
    }

    if (image) preloadUpsellImage(image);
    var imageHtml = image ? ('<img class="cart-drawer__upsell-image" src="' + image + '" alt="" loading="lazy" decoding="async" fetchpriority="low">') : '<div class="cart-drawer__upsell-image"></div>';

    cardEl.innerHTML =
      '<div class="cart-drawer__upsell-top">' +
        '<div class="cart-drawer__upsell-head">OFFRE FLASH : 2E MAILLOT À 11,99€</div>' +
        '<div class="cart-drawer__upsell-top-right">' +
          '<div class="cart-drawer__upsell-timer"><span data-upsell-timer>' + timerText + '</span></div>' +
          (suggestedCount > 1 ? '<button type="button" class="cart-drawer__upsell-next-btn" id="CartDrawerUpsellNext" aria-label="Voir un autre maillot"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"/></svg></button>' : '') +
        '</div>' +
      '</div>' +
      '<div class="cart-drawer__upsell-body">' +
        '<div class="cart-drawer__upsell-media">' + imageHtml + '</div>' +
        '<div class="cart-drawer__upsell-info">' +
          '<p class="cart-drawer__upsell-title">' + (function(){var sp=splitTitleAtDash(title);if(sp)return '<span class="cd-title-club">'+escapeHtml(sp[0])+'</span><span class="cd-title-sub">'+escapeHtml(sp[1])+'</span>';return '<span class="cd-title-club">'+escapeHtml(title)+'</span>';})() + '</p>' +
          '<p class="cart-drawer__upsell-sub">Choisis parmi 2 maillots pour seulement 11,99\u20AC et économise 8\u20AC instantanément sur ta commande.</p>' +
        '</div>' +
      '</div>' +
      '<div class="cart-drawer__upsell-sizes">' + chips + '</div>' +
      '<div class="cart-drawer__upsell-bottom">' +
        '<div class="cart-drawer__upsell-price-wrap">' +
          '<p class="cart-drawer__upsell-price"><strong>' + specialPrice + '</strong></p>' +
          '<p class="cart-drawer__upsell-old"><del>' + normalPrice + '</del></p>' +
        '</div>' +
        '<span class="cart-drawer__upsell-gain-chip">+8€ économisés</span>' +
        '<button type="button" id="CartDrawerAddNeutral1199" class="cart-drawer__upsell-add-btn" aria-label="Ajouter offre spéciale"><span class="cart-drawer__upsell-add-icon">+</span><span>Ajouter pour ' + specialPrice + '</span></button>' +
      '</div>';
    cardEl.classList.remove('cart-drawer__upsell-card--ab-a', 'cart-drawer__upsell-card--ab-b', 'is-last-chance', 'is-searching');
    cardEl.classList.add(getUpsellABVariant() === 'b' ? 'cart-drawer__upsell-card--ab-b' : 'cart-drawer__upsell-card--ab-a');
    if (isExpiredNow) cardEl.classList.add('is-last-chance');
    cardEl.style.display = '';
    startUpsellCardTimer(cardEl);
  }

  function cartHasCode(cart, code) {
    if (!cart || !Array.isArray(cart.discount_codes)) return false;
    var target = String(code || '').toUpperCase();
    if (!target) return false;
    return cart.discount_codes.some(function (d) {
      return d && String(d.code || '').toUpperCase() === target;
    });
  }

  function shouldKeepUpsellCode(cart) {
    if (!cartHasCode(cart, UPSELL_DISCOUNT_CODE)) return true;
    if (!cartHasUpsellLine(cart)) return false;
    if (getNonWarrantyItemCount(cart) !== 2) return false;
    if (!isUpsellSessionActive()) return false;
    return true;
  }

  function clearUpsellCodeIfInvalid(cart) {
    var keep = shouldKeepUpsellCode(cart);
    if (keep) return Promise.resolve(cart);
    setUpsellSessionActive(false);

    // [ANNOTATION | DATE: 2026-02-15]
    // WHY: eviter le glitch ou le code UPSELL reste actif sur des paniers sans upsell.
    // DO NOT CHANGE: suppression automatique quand conditions upsell non respectees.
    // IMPACT: plus de remise fantome sur des maillots normaux.
    return fetchJSON('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: '' })
    }).catch(function () {
      return cart;
    });
  }

  // [ANNOTATION | DATE: 2026-02-16]
  // WHY: caches mémoire pour éviter les scans catalogue répétés sur chaque refresh du drawer.
  // IMPACT: ouverture panier plus fluide et moins d'appels réseau.
  var upsellSuggestionByBaseKey = {};
  var upsellNoSuggestionByBaseKey = {};
  var upsellNoSuggestionByClubToken = {};
  var upsellSuggestionScanPromiseByKey = {};
  var currentUpsellSuggestions = [];
  var upsellLineKeyLookup = Object.create(null);

  function getUpsellCardIndex() {
    try {
      var raw = parseInt(sessionStorage.getItem(UPSELL_CARD_INDEX_KEY) || '0', 10);
      return isFinite(raw) ? Math.max(0, raw) : 0;
    } catch (e) {
      return 0;
    }
  }

  function setUpsellCardIndex(index) {
    var next = Math.max(0, parseInt(index, 10) || 0);
    try { sessionStorage.setItem(UPSELL_CARD_INDEX_KEY, String(next)); } catch (e) {}
  }

  function getActiveUpsellSuggestion() {
    if (!Array.isArray(currentUpsellSuggestions) || !currentUpsellSuggestions.length) return null;
    var idx = getUpsellCardIndex();
    if (idx >= currentUpsellSuggestions.length) idx = 0;
    return currentUpsellSuggestions[idx] || null;
  }

  function setCurrentUpsellSuggestions(list) {
    // [ANNOTATION | DATE: 2026-02-16]
    // WHY: renvoyer un booléen "changed" pour rerender uniquement quand la suggestion change réellement.
    // IMPACT: évite des re-renders inutiles.
    var nextList = Array.isArray(list) ? list : [];
    var unique = [];
    var seen = Object.create(null);
    for (var i = 0; i < nextList.length; i++) {
      var product = nextList[i];
      if (!product || !product.handle) continue;
      var handle = String(product.handle || '').trim();
      if (!handle || seen[handle]) continue;
      seen[handle] = true;
      unique.push(product);
      if (unique.length >= 2) break;
    }
    var prevKey = Array.isArray(currentUpsellSuggestions)
      ? currentUpsellSuggestions.map(function (p) { return String((p && p.handle) || ''); }).join('|')
      : '';
    var nextKey = unique.map(function (p) { return String((p && p.handle) || ''); }).join('|');
    currentUpsellSuggestions = unique;
    if (nextKey !== prevKey) setUpsellCardIndex(0);
    return prevKey !== nextKey;
  }

  function extractClubNameFromTitle(title) {
    var raw = String(title || '').trim();
    if (!raw) return '';
    var firstPart = raw.split(/[\u2013\u2014-]/)[0] || raw;
    return firstPart.replace(/\([^)]*\)/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function clubTokenFromTitle(title) {
    return normalizeSimple(extractClubNameFromTitle(title || ''));
  }

  function productHasAvailableVariant(product) {
    if (!product || !Array.isArray(product.variants)) return false;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (!v) continue;
      if (v.available === false) continue;
      if (parseInt(v.id, 10)) return true;
    }
    return false;
  }

  function productMatchesClub(product, clubToken, excludedHandle) {
    if (!product || !clubToken) return false;
    var handle = String(product.handle || '').trim();
    if (!handle) return false;
    if (excludedHandle && handle === excludedHandle) return false;
    if (!productHasAvailableVariant(product)) return false;

    var titleToken = clubTokenFromTitle(product.title || '');
    if (!titleToken) return false;
    if (titleToken === clubToken) return true;
    if (titleToken.indexOf(clubToken) >= 0) return true;
    if (clubToken.indexOf(titleToken) >= 0) return true;
    return false;
  }

  function productImageUrl(product) {
    if (!product) return '';
    if (product.image && product.image.src) return String(product.image.src);
    if (typeof product.featured_image === 'string' && product.featured_image) return String(product.featured_image);
    if (product.featured_image && product.featured_image.src) return String(product.featured_image.src);
    if (Array.isArray(product.images) && product.images.length) {
      var first = product.images[0];
      if (typeof first === 'string') return first;
      if (first && first.src) return String(first.src);
    }
    return '';
  }

  function prefetchUpsellSuggestionForCart(cart) {
    var changed = setCurrentUpsellSuggestions([]);
    if (!canOfferUpsell(cart)) return Promise.resolve(changed);

    var base = getPrimaryCartItemForUpsell(cart);
    if (!base) return Promise.resolve(changed);

    var baseKey = String(base.key || '');
    var baseHandle = getItemHandle(base);
    var clubToken = clubTokenFromTitle(base.product_title || base.title || '');
    if (!clubToken) return Promise.resolve(changed);
    if (baseKey && upsellNoSuggestionByBaseKey[baseKey]) return Promise.resolve(changed);
    if (baseKey && Array.isArray(upsellSuggestionByBaseKey[baseKey]) && upsellSuggestionByBaseKey[baseKey].length) {
      var cached = [];
      for (var ci = 0; ci < upsellSuggestionByBaseKey[baseKey].length; ci++) {
        var cp = upsellSuggestionByBaseKey[baseKey][ci];
        if (productMatchesClub(cp, clubToken, baseHandle)) cached.push(cp);
      }
      if (cached.length) {
        changed = setCurrentUpsellSuggestions(cached) || changed;
        return Promise.resolve(changed);
      }
    }
    if (upsellNoSuggestionByClubToken[clubToken]) return Promise.resolve(changed);

    var storageKey = baseKey ? ('covred_upsell_suggest_handle_' + baseKey) : '';
    var storedHandle = '';
    try { if (storageKey) storedHandle = sessionStorage.getItem(storageKey) || ''; } catch (e) {}
    if (storedHandle === '__none__') {
      if (baseKey) upsellNoSuggestionByBaseKey[baseKey] = true;
      upsellNoSuggestionByClubToken[clubToken] = true;
      return Promise.resolve(changed);
    }

    function acceptProducts(products, preferredHandle) {
      if (!Array.isArray(products) || !products.length) return false;
      var valid = [];
      for (var i = 0; i < products.length; i++) {
        var product = products[i];
        if (!productMatchesClub(product, clubToken, baseHandle)) continue;
        valid.push(product);
      }
      if (!valid.length) return false;

      var picked = [];
      var used = Object.create(null);
      if (preferredHandle) {
        for (var j = 0; j < valid.length; j++) {
          var ph = String((valid[j] && valid[j].handle) || '').trim();
          if (ph && ph === preferredHandle) {
            picked.push(valid[j]);
            used[ph] = true;
            break;
          }
        }
      }
      var pool = [];
      for (var k = 0; k < valid.length; k++) {
        var p = valid[k];
        var h = String((p && p.handle) || '').trim();
        if (!h || used[h]) continue;
        pool.push(p);
      }
      while (pool.length && picked.length < 2) {
        var idx = Math.floor(Math.random() * pool.length);
        var chosen = pool.splice(idx, 1)[0];
        if (!chosen) continue;
        picked.push(chosen);
      }
      if (!picked.length) return false;

      changed = setCurrentUpsellSuggestions(picked) || changed;
      if (baseKey) upsellSuggestionByBaseKey[baseKey] = picked;
      if (baseKey) upsellNoSuggestionByBaseKey[baseKey] = false;
      upsellNoSuggestionByClubToken[clubToken] = false;
      for (var m = 0; m < picked.length; m++) {
        var img = productImageUrl(picked[m]);
        if (img) preloadUpsellImage(img);
      }
      try {
        if (storageKey && picked[0] && picked[0].handle) sessionStorage.setItem(storageKey, String(picked[0].handle));
      } catch (e) {}
      return true;
    }

    function scanCatalog() {
      var scanKey = clubToken + '|' + (baseHandle || '');
      if (!upsellSuggestionScanPromiseByKey[scanKey]) {
        var maxPages = 8;
        var pageTasks = [];
        for (var p = 1; p <= maxPages; p++) {
          pageTasks.push(fetchProductsPage(p));
        }

        // [ANNOTATION | DATE: 2026-02-16]
        // WHY: scan parallèle des pages catalogue au lieu d'un enchaînement séquentiel lent.
        // IMPACT: suggestion upsell visible beaucoup plus vite.
        upsellSuggestionScanPromiseByKey[scanKey] = Promise.all(pageTasks).then(function (pages) {
          var pool = [];
          for (var i = 0; i < pages.length; i++) {
            if (!Array.isArray(pages[i])) continue;
            for (var j = 0; j < pages[i].length; j++) {
              var candidate = pages[i][j];
              if (!productMatchesClub(candidate, clubToken, baseHandle)) continue;
              pool.push(candidate);
            }
          }
          return pool;
        }).catch(function () {
          return [];
        });
      }

      return upsellSuggestionScanPromiseByKey[scanKey].then(function (pool) {
        if (acceptProducts(pool, storedHandle && storedHandle !== baseHandle ? storedHandle : '')) return changed;
        if (baseKey) upsellNoSuggestionByBaseKey[baseKey] = true;
        upsellNoSuggestionByClubToken[clubToken] = true;
        try { if (storageKey) sessionStorage.setItem(storageKey, '__none__'); } catch (e) {}
        return changed;
      });
    }

    return scanCatalog();
  }

  var compareAtByVariantId = {};
  var compareAtFetchByHandle = {};

  function getItemHandle(it) {
    if (!it) return '';
    if (it.handle) return String(it.handle);
    var url = String(it.url || '');
    var m = url.match(/\/products\/([^/?#]+)/i);
    return m && m[1] ? m[1] : '';
  }

  function cacheCompareAtFromProduct(product) {
    if (!product || !Array.isArray(product.variants)) return false;
    var changed = false;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      if (!v) continue;
      var id = parseInt(v.id, 10) || 0;
      if (!id) continue;
      var compare = parseInt(v.compare_at_price || '0', 10) || 0;
      if (!Object.prototype.hasOwnProperty.call(compareAtByVariantId, id) || compareAtByVariantId[id] !== compare) {
        compareAtByVariantId[id] = compare;
        changed = true;
      }
    }
    return changed;
  }

  function prefetchCompareAtForCart(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) return Promise.resolve(false);
    var tasks = [];

    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var vid = parseInt((it && (it.id || it.variant_id)) || 0, 10) || 0;
      if (vid && Object.prototype.hasOwnProperty.call(compareAtByVariantId, vid)) continue;

      var handle = getItemHandle(it);
      if (!handle) continue;

      if (!compareAtFetchByHandle[handle]) {
        compareAtFetchByHandle[handle] = fetchProductByHandle(handle).then(function (product) {
          return cacheCompareAtFromProduct(product);
        }).catch(function () {
          return false;
        });
      }
      tasks.push(compareAtFetchByHandle[handle]);
    }

    if (!tasks.length) return Promise.resolve(false);
    return Promise.all(tasks).then(function (results) {
      for (var i = 0; i < results.length; i++) {
        if (results[i]) return true;
      }
      return false;
    });
  }

  // -------------------------
  // Render + scheduling (coalescing)
  // -------------------------
  var renderToken = 0;           // anti-race: seul le dernier rendu gagne
  var cartFetchAbort = null;     // pour aborter /cart.js si on relance vite
  var afterRenderScheduled = false;
  var lastCart = null;           // dernier cart rendu (pour détecter options)
  var upsellNoticeTimer = null;
  var upsellNoticeHideTimer = null;
  var upsellCardTimer = null;
  /* [PHASE 5A.1] Variables d'état warranty + fonctions begin/end/forceUnlockWarrantyIfStale supprimées — code mort. */
  var drawerLoadingTimer = null;
  var drawerLoadingTicket = 0;

  function setDrawerLoading(active, ticket) {
    var dom = getDom();
    if (!dom || !dom.drawer) return;

    if (!active) {
      if (drawerLoadingTimer) {
        clearTimeout(drawerLoadingTimer);
        drawerLoadingTimer = null;
      }
      dom.drawer.classList.remove('is-loading');
      return;
    }

    if (drawerLoadingTimer) {
      clearTimeout(drawerLoadingTimer);
      drawerLoadingTimer = null;
    }

    // [ANNOTATION | DATE: 2026-02-16]
    // WHY: micro-délai anti-flicker; on n'affiche le skeleton que si la requête prend vraiment un peu de temps.
    // IMPACT: sensation de fluidité sans clignotement sur les réponses rapides.
    drawerLoadingTimer = setTimeout(function () {
      if (ticket !== drawerLoadingTicket) return;
      var latest = getDom();
      if (!latest || !latest.drawer) return;
      latest.drawer.classList.add('is-loading');
    }, 90);
  }

  function stopUpsellCardTimer() {
    if (upsellCardTimer) {
      clearInterval(upsellCardTimer);
      upsellCardTimer = null;
    }
  }

  function startUpsellCardTimer(cardEl) {
    stopUpsellCardTimer();
    if (!cardEl) return;

    var timerEl = cardEl.querySelector('[data-upsell-timer]');
    var headEl = cardEl.querySelector('.cart-drawer__upsell-head');
    var subEl = cardEl.querySelector('.cart-drawer__upsell-sub');
    if (!timerEl) return;

    function tick() {
      var left = getUpsellDeadlineMs() - Date.now();
      var expired = left <= 0;
      timerEl.textContent = formatCountdown(left);
      cardEl.classList.toggle('is-last-chance', expired);
      if (expired) {
        try { sessionStorage.setItem(UPSELL_TIMER_EXPIRED_KEY, '1'); } catch (e) {}
      }
      if (expired) {
        if (headEl) headEl.textContent = 'OFFRE BIENTÔT TERMINÉE';
        if (subEl) subEl.textContent = 'Choisis parmi 2 maillots pour seulement 11,99\u20AC. Cette offre expire dans quelques instants.';
      } else {
        try { sessionStorage.removeItem(UPSELL_TIMER_EXPIRED_KEY); } catch (e) {}
        if (headEl) headEl.textContent = 'OFFRE FLASH : 2E MAILLOT À 11,99€';
        if (subEl) subEl.textContent = 'Choisis parmi 2 maillots pour seulement 11,99\u20AC et \u00E9conomise 8\u20AC instantan\u00E9ment sur ta commande.';
      }
    }

    tick();
    upsellCardTimer = setInterval(tick, 1000);
  }

  function clearUpsellNotice(el) {
    if (!el) return;
    if (upsellNoticeTimer) {
      clearTimeout(upsellNoticeTimer);
      upsellNoticeTimer = null;
    }
    if (upsellNoticeHideTimer) {
      clearTimeout(upsellNoticeHideTimer);
      upsellNoticeHideTimer = null;
    }
    el.classList.remove('is-visible');
    el.style.display = 'none';
    el.textContent = '';
  }

  function showUpsellNotice(el, text, durationMs) {
    if (!el) return;
    clearUpsellNotice(el);

    el.textContent = text || '';
    el.style.display = '';

    requestAnimationFrame(function () {
      el.classList.add('is-visible');
    });

    upsellNoticeTimer = setTimeout(function () {
      el.classList.remove('is-visible');
      upsellNoticeHideTimer = setTimeout(function () {
        el.style.display = 'none';
        el.textContent = '';
      }, 300);
    }, durationMs || 4200);
  }

  /* [PHASE 5A.1] getWarrantyMinPrice, getFirstWarrantyVariantId supprimés — code mort. */

  /* [PHASE 5A.1] initWarrantyModalDraft supprimé — code mort. */

  /* [PHASE 5A.1] getNonWarrantyTargets supprimé — code mort. */

  /* [PHASE 5A.1] syncWarrantySelections supprimé — code mort. */

  /* [PHASE 5A.1] renderWarrantyOffer supprimé — code mort. */

  /* [PHASE 5A.1] ensureWarrantyModalRoot supprimé — code mort. */

  /* [PHASE 5A.1] renderWarrantyModal, refreshWarrantyModalInteractive, setWarrantyPopupOpenState,
     addWarrantyVariantToCart, removeWarrantyFromCart, cleanupOrphanWarrantyLines — tous supprimés (code mort). */

  function scheduleAfterRender() {
    if (afterRenderScheduled) return;
    afterRenderScheduled = true;

    // double rAF = laisse le DOM se poser + paint (remplace ton setTimeout(50) de manière plus fluide)
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        afterRenderScheduled = false;

        document.dispatchEvent(new Event('cart:updated'));
        document.dispatchEvent(new Event('cart:refresh'));
      });
    });
  }

  /* [ANNOTATION | DATE: 2026-04-05]
     WHY: le cart drawer peut recevoir un cart avec un état discount incohérent
     (offre invalide mais code encore présent, ou offre valide mais code absent).
     On corrige AVANT le rendu : on envoie le bon état discount à Shopify,
     puis on re-fetch le panier et on re-rend.
     IMPACT: le drawer ne montre JAMAIS un prix décalé par rapport au checkout. */
  var _offerSyncLock = false;
  function renderCart(cart) {
    var dom = getDom();
    if (!dom || !dom.drawer) return;

    /* [ANNOTATION | DATE: 2026-04-15]
       WHY: après la libération de window._covredOfferLock par la chaîne ATC, Shopify
       peut mettre jusqu'à ~500ms à propager l'état panier + discount code complet.
       Si on lance le sync juste après, on risque de voir un état incohérent et de
       POST un /cart/update.js inutile qui annule le code qu'on vient d'appliquer.
       D'où ce cool-down de 500ms après la libération du lock.
       IMPACT: plus de flash entre ATC offre et affichage du drawer. */
    var _cdReleasedAt = window._covredOfferLockReleasedAt || 0;
    var _cdCoolingDown = _cdReleasedAt && (Date.now() - _cdReleasedAt) < 500;

    if (!_offerSyncLock && !window._covredOfferLock && !_cdCoolingDown && cart && cart.items) {
      /* [PHASE 3B.4] Utilise getOfferState centralisé (covred-cart-utils.js) au lieu
         de dupliquer la logique de comptage offre/normal et la lecture des codes.
         Source unique de vérité = moins de bugs, moins de code à maintenir. */
      var _sdk = [57,75,65,87,84,72,81,80,49,83,68,65];
      var _sdc = _sdk.map(function(c){ return String.fromCharCode(c); }).join('');
      var sOfferCode4 = '05CRANPQ3ED8';
      var _state = (window.COVRED && window.COVRED.cart && window.COVRED.cart.getOfferState)
        ? window.COVRED.cart.getOfferState(cart)
        : null;

      /* Fallback inline si covred-cart-utils pas chargé (rétro-compat) */
      var sOfferQty, sNormalQty, sHasCode;
      if (_state) {
        sOfferQty = _state.offerQty;
        sNormalQty = _state.normalQty;
        sHasCode = _state.offerCodeApplied;
      } else {
        sOfferQty = 0; sNormalQty = 0; sHasCode = false;
        for (var si = 0; si < cart.items.length; si++) {
          if (cart.items[si].properties && cart.items[si].properties._offer === 'decouverte') {
            sOfferQty += cart.items[si].quantity;
          } else {
            sNormalQty += cart.items[si].quantity;
          }
        }
        if (cart.discount_codes) {
          for (var sd = 0; sd < cart.discount_codes.length; sd++) {
            if (cart.discount_codes[sd].code === _sdc || cart.discount_codes[sd].code === sOfferCode4) { sHasCode = true; break; }
          }
        }
      }

      /* Déterminer le type d'offre (2 ou 4) et le code correspondant */
      var sOfferType = '2';
      try { sOfferType = sessionStorage.getItem('covred_offer_type') || '2'; } catch(ex){}
      var sActiveCode = sOfferType === '4' ? sOfferCode4 : _sdc;
      var sRequiredQty = sOfferType === '4' ? 4 : 2;

      var sOfferValid = sOfferQty >= sRequiredQty && sNormalQty === 0;
      /* One-shot : vérifier le flag session avant de ré-appliquer */
      var sOfferFlag = false;
      try { sOfferFlag = sessionStorage.getItem('covred_offer_active') === '1'; } catch(ex){}

      var shouldApply = sOfferValid && !sHasCode && sOfferFlag;
      var shouldRemove = sHasCode && (!sOfferValid || !sOfferFlag);

      if (shouldRemove) {
        /* Offre invalidée → retirer code + flag */
        try { sessionStorage.removeItem('covred_offer_active'); sessionStorage.removeItem('covred_offer_type'); } catch(ex){}
      }

      if (shouldApply || shouldRemove) {
        _offerSyncLock = true;
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: shouldApply ? sActiveCode : '' })
        })
        .then(function(r){ return r.json(); })
        .then(function(updatedCart){
          /* [PHASE 9B.4] Shopify retourne directement le cart frais dans la réponse
             POST /cart/update.js. Pas besoin de re-fetch /cart.js avec setTimeout 500ms.
             Gain : -500ms par sync drawer. */
          _offerSyncLock = false;
          if (window.COVRED && COVRED.cart) COVRED.cart.invalidateCache();
          renderCart(updatedCart);
        })
        .catch(function(){ _offerSyncLock = false; });
        return;
      }
    }

    var itemsWrap = dom.itemsWrap;
    var empty = dom.empty;
    var subtotal = dom.subtotal;
    var tpl = dom.tpl;
    var discountMsg = dom.discountMsg;
    var savingsEl = dom.savings;
    var upsellCard = dom.upsellCard;
    var upsellNoticeEl = dom.upsellNoticeEl;
    var warrantySlot = dom.warrantySlot;
    var progressSlot = dom.progressSlot;

    if (!itemsWrap || !subtotal || !tpl || !tpl.content) return;

    var items = (cart && cart.items) ? cart.items : [];
    /* [PHASE 5A.1] Ordre naturel du panier conservé. L'ancienne logique de tri warranty
       (annotation 2026-02-17) a été retirée en même temps que le code warranty. */
    var renderItems = [];
    for (var iMap = 0; iMap < items.length; iMap++) {
      renderItems.push({ item: items[iMap], idx: iMap });
    }
    lastCart = cart || null;
    if (!cartHasUpsellLine(cart)) setUpsellSessionActive(false);

    // Empty state
    if (!items.length) {
      if (empty) {
        empty.style.display = 'block';
        renderEmptyDrawerMarketing(empty);
      }
      safeReplaceChildren(itemsWrap, document.createDocumentFragment());
      animateSubtotalCounter(subtotal, (cart && cart.total_price) ? cart.total_price : 0, 0);
      upsellLineKeyLookup = Object.create(null);

      var checkoutBtn = dom.checkoutBtn;
      if (checkoutBtn) {
        checkoutBtn.setAttribute('aria-disabled', 'true');
        checkoutBtn.style.pointerEvents = 'none';
        checkoutBtn.style.opacity = '0.45';
      }

      // code promo msg — hide offer code (not stackable)
      if (discountMsg) {
        if (cart.discount_codes && cart.discount_codes.length) {
          var _hk = [57,75,65,87,84,72,81,80,49,83,68,65];
          var _hc = _hk.map(function(c){ return String.fromCharCode(c); }).join('');
          var _hc0_4 = '05CRANPQ3ED8';
          var hasOffer = cart.discount_codes.some(function(d){ return d.code === _hc || d.code === _hc0_4; });
          if (hasOffer) {
            var _emOt = '2';
            try { _emOt = sessionStorage.getItem('covred_offer_type') || '2'; } catch(ex){}
            var _emLbl = _emOt === '4' ? 'Offre D\u00e9couverte activ\u00e9e \u2014 4 maillots' : 'Offre D\u00e9couverte activ\u00e9e';
            discountMsg.innerHTML = '<span style="color:#31d39d;font-weight:600;">' + _emLbl + '</span>';
          } else {
            discountMsg.innerHTML = 'Code appliqu\u00e9 : <strong>' + escapeHtml(cart.discount_codes.map(function(d){ return d.code; }).join(', ')) + '</strong>';
          }
        } else {
          discountMsg.innerHTML = '';
        }
      }

      renderUpsellCard(upsellCard, cart);
      /* [PHASE 5A.1] Bloc warranty supprimé — code mort. On cache juste le slot. */
      if (warrantySlot) {
        warrantySlot.style.display = 'none';
        warrantySlot.innerHTML = '';
      }
      if (progressSlot) {
        progressSlot.style.display = 'none';
        progressSlot.innerHTML = '';
      }
      if (savingsEl) {
        savingsEl.style.display = 'none';
        savingsEl.textContent = '';
      }
      if (upsellNoticeEl) {
        clearUpsellNotice(upsellNoticeEl);
      }
      return;
    }

    if (empty) empty.style.display = 'none';

    // réactive checkout si panier non vide
    var checkoutBtn2 = dom.checkoutBtn;
    if (checkoutBtn2) {
      checkoutBtn2.removeAttribute('aria-disabled');
      checkoutBtn2.style.pointerEvents = '';
      checkoutBtn2.style.opacity = '';
    }
    var frag = document.createDocumentFragment();
    upsellLineKeyLookup = Object.create(null);
    var correctedTotal = 0;
    var originalTotal = 0;
    var fakeCompareTotal = 0;
    var hasUpsell = cartHasUpsellLine(cart);
    var isUpsellActive = isUpsellSessionActive();
    var hasUpsellDiscountActive = isUpsellDiscountActiveOnCart(cart);
    var forceUpsellVisualPricing = hasUpsell && isUpsellActive && hasUpsellDiscountActive;
    var upsellDiscountRemaining = forceUpsellVisualPricing ? 800 : 0;

    /* [ANNOTATION | DATE: 2026-04-05]
       WHY: l'offre découverte est EXCLUSIVE. Le style spécial (bordure verte, label, qty lock)
       ne doit s'appliquer que si le panier ne contient QUE des items offre.
       Dès qu'un maillot normal est présent, les items offre redeviennent des items normaux.
       IMPACT: pas de label trompeur quand l'offre est invalide. */
    var offerOnlyCart = true;
    var offerItemsInCart = 0;
    for (var oc = 0; oc < renderItems.length; oc++) {
      var ocIt = renderItems[oc].item;
      if (ocIt && ocIt.properties && String(ocIt.properties._offer || '') === 'decouverte') {
        offerItemsInCart += ocIt.quantity;
      } else {
        offerOnlyCart = false;
      }
    }
    /* Déterminer le type d'offre (2 ou 4) */
    var _offerType = '2';
    try { _offerType = sessionStorage.getItem('covred_offer_type') || '2'; } catch(ex){}
    var _offerReqQty = _offerType === '4' ? 4 : 2;
    if (offerItemsInCart < _offerReqQty) offerOnlyCart = false;
    /* Aussi vérifier que le discount est RÉELLEMENT appliqué */
    if (offerOnlyCart) {
      var _odk = [57,75,65,87,84,72,81,80,49,83,68,65];
      var _odc = _odk.map(function(c){ return String.fromCharCode(c); }).join('');
      var _odc4 = '05CRANPQ3ED8';
      var offerCodeInCart = false;
      if (cart && cart.discount_codes) {
        for (var odc = 0; odc < cart.discount_codes.length; odc++) {
          if (cart.discount_codes[odc].code === _odc || cart.discount_codes[odc].code === _odc4) { offerCodeInCart = true; break; }
        }
      }
      if (!offerCodeInCart) offerOnlyCart = false;
    }
    // [ANNOTATION | DATE: 2026-02-16]
    // WHY: donner un feedback visuel immédiat quand la ligne offre spéciale vient d'être ajoutée.
    // IMPACT: le client perçoit instantanément l'action "ajout au panier" sans effet cheap.
    var shouldAnimateUpsellLine = consumeUpsellJustAddedMarker();

    renderUpsellCard(upsellCard, cart);
    /* [PHASE 5A.1] renderWarrantyOffer() retiré — code warranty supprimé */

    for (var i = 0; i < renderItems.length; i++) {
      var it = renderItems[i].item;
      var node = tpl.content.cloneNode(true);

      var root = node.querySelector('.cart-drawer__item');
      var titleEl = node.querySelector('.cart-drawer__item-title');
      var priceEl = node.querySelector('.cart-drawer__item-lineprice');
      var thumbLink = node.querySelector('.cart-drawer__thumb');
      var thumbImg = node.querySelector('.cart-drawer__thumb-img');

      if (root) root.setAttribute('data-key', it.key || '');

      var titleText = it.product_title || it.title || '';
      var url = it.url || '#';

      if (titleEl) {
        var splitResult = splitTitleAtDash(titleText);
        if (splitResult) {
          titleEl.innerHTML = '<span class="cd-title-club">' + escapeHtml(splitResult[0]) + '</span>'
            + '<span class="cd-title-sub">' + escapeHtml(splitResult[1]) + '</span>';
        } else {
          titleEl.innerHTML = '<span class="cd-title-club">' + escapeHtml(titleText) + '</span>';
        }
        titleEl.href = url;
      }
      if (thumbLink) thumbLink.href = url;

      // Image
      if (thumbImg) {
        var imgSrc = '';
        if (it.image) imgSrc = it.image;
        else if (it.featured_image && it.featured_image.url) imgSrc = it.featured_image.url;

        if (imgSrc) {
          thumbImg.src = imgSrc;
          thumbImg.alt = titleText;
          thumbImg.style.display = '';
          if (thumbLink) thumbLink.style.display = '';
        } else {
          thumbImg.style.display = 'none';
          if (thumbLink) thumbLink.style.display = 'none';
        }
      }

      var qtyInput = node.querySelector('.cd-qty-input');
      if (qtyInput) {
        qtyInput.value = it.quantity || 0;
      }

      // Meta raw (variant + properties)
      var metaParts = [];

      if (it.variant_title && it.variant_title !== 'Default Title') {
        metaParts.push(it.variant_title);
      }

      if (it.properties) {
        /* [PHASE 5A.1] Filtres warranty "Garantie sur" et /^G\d+$/ retirés — code warranty supprimé */
        for (var k in it.properties) {
          if (!Object.prototype.hasOwnProperty.call(it.properties, k)) continue;

          var v = it.properties[k];
          if (!v) continue;
          if (String(k).indexOf('_') === 0) continue;
          // Evite le doublon "Size: X" en propriété texte; la taille vient déjà de la variante Shopify.
          if (String(k).toLowerCase() === 'size') continue;

          metaParts.push(String(k) + ': ' + String(v));
        }
      }

      var metaRaw = metaParts.join(' • ');

      // Meta affichée (clean)
      var clean = stripAddonPrices(metaRaw);

      // Même logique que ton code (gardée), juste sans map/filter lourds
      var parts = clean.split('•');
      var normParts = [];
      for (var p = 0; p < parts.length; p++) {
        var t = String(parts[p]).trim();
        if (t) normParts.push(t);
      }

      var size = normParts.length ? normParts[0] : '';
      var rest = normParts.length > 1 ? normParts.slice(1) : [];

      // Retire les intitulés "Nom:", "Numéro:", etc.
      var rest2 = [];
      for (var r = 0; r < rest.length; r++) {
        var rr = String(rest[r]).replace(/^.*?:\s*/g, '').trim();
        if (rr) rest2.push(rr);
        if (rest2.length >= 3) break; // Limite à 3 infos max
      }
      rest = rest2;

      /* [PHASE 5A.1] isWarrantyLine retiré — code warranty supprimé */
      var isUpsellLine = !!(it && it.properties && (
        String(it.properties._covred_upsell_offer || '') === '1' ||
        String(it.properties._covred_neutral_addon || '') === '1199'
      ));
      /* [ANNOTATION | DATE: 2026-04-05]
         WHY: items from the "Offre Découverte" bottom-sheet have _offer:'decouverte'.
         They need a distinct visual in the cart drawer (green accent, "Offre Découverte" label).
         IMPACT: client immediately sees which items are part of the offer. */
      /* isOfferLine only true when offer is valid (cart = offer items only) */
      var isOfferLine = offerOnlyCart && !!(it && it.properties && String(it.properties._offer || '') === 'decouverte');
      if (isUpsellLine && it && it.key) upsellLineKeyLookup[String(it.key)] = true;
      var isUpsellHighlighted = isUpsellLine && forceUpsellVisualPricing;
      if (root) {
        root.classList.toggle('is-upsell-line', isUpsellHighlighted);
        root.setAttribute('data-upsell-line', isUpsellHighlighted ? '1' : '0');
        root.classList.toggle('is-offer-line', isOfferLine);
        root.setAttribute('data-offer-line', isOfferLine ? '1' : '0');
        if (isUpsellHighlighted && shouldAnimateUpsellLine) {
          root.classList.add('is-upsell-line-enter');
          shouldAnimateUpsellLine = false;
        }
      }

      // Taille
      var sizeEl = node.querySelector('.cd-size');
      if (isUpsellLine && it && it.properties && it.properties.Size) {
        size = String(it.properties.Size);
      }
      if (sizeEl && size) {
        sizeEl.textContent = size;
      }

      if (isUpsellLine || isOfferLine) {
        // [ANNOTATION | DATE: 2026-02-15 / 2026-04-05]
        // WHY: la quantité des lignes offre spéciale et offre découverte doit rester fixe.
        // IMPACT: pas de modification +/- ni saisie manuelle sur ces lignes.
        var stepper = node.querySelector('.cd-qty-stepper');
        var minusBtn = node.querySelector('.cd-qty-btn[data-dir="-1"]');
        var plusBtn = node.querySelector('.cd-qty-btn[data-dir="1"]');
        if (stepper) stepper.classList.add('is-disabled');
        if (minusBtn) minusBtn.disabled = true;
        if (plusBtn) plusBtn.disabled = true;
        if (qtyInput) {
          qtyInput.setAttribute('readonly', 'readonly');
          qtyInput.setAttribute('aria-readonly', 'true');
          qtyInput.setAttribute('tabindex', '-1');
        }
      }

      // Flocage (ligne dédiée)
      var flocLine = node.querySelector('.cart-drawer__floc-line');
      if (flocLine) {
        var details = sanitizeLegacyOfferDetails(rest.length ? rest.join(' • ') : '');
        if (isUpsellLine && forceUpsellVisualPricing) {
          // [ANNOTATION | DATE: 2026-02-16]
          // WHY: le client ne doit jamais voir le terme technique "upsell".
          // IMPACT: wording marketing propre et orienté conversion.
          setFlocLineContent(flocLine, details ? ('Offre spéciale (-8€) • ' + details) : 'Offre spéciale (-8€)');
        } else if (details) {
          /* [PHASE 5A.1] Branche isWarrantyLine retirée — code warranty supprimé */
          setFlocLineContent(flocLine, details);
        } else {
          setFlocLineContent(flocLine, '');
        }
      }

      // ----------------------------------------------------
      // ⚠️ PRIX / CALCUL: STRICTEMENT IDENTIQUE À TON ORIGINAL
      // ----------------------------------------------------
      // Prix
      var basePrice = it.line_price || 0; // après promo Shopify
      var qty = it.quantity || 1;

      // Extra flocage (par unité) via meta raw ou comptage propriétés "Flocage …"
      var extraPerUnit = extractExtraCents(metaRaw);
      if (extraPerUnit === 0) {
        extraPerUnit = countFlocageProperties(it) * FLOCAGE_UNIT_CENTS;
      }
      var extraTotal = extraPerUnit * qty;

      // Ratio promo Shopify appliqué sur l'item
      var ratio = 1;
      if (it.original_line_price && it.original_line_price > 0) {
        ratio = (it.line_price || 0) / it.original_line_price;
        if (!isFinite(ratio) || ratio <= 0) ratio = 1;
      }

      // On applique la promo au flocage aussi
      var extraDiscounted = Math.round(extraTotal * ratio);

      var displayPrice = basePrice + extraDiscounted;
      var originalDisplayPrice = displayPrice;

      if (it.original_line_price && it.original_line_price > 0) {
        originalDisplayPrice = it.original_line_price + extraTotal;
      }

      if (forceUpsellVisualPricing && it.original_line_price && it.original_line_price > 0) {
        // [ANNOTATION | DATE: 2026-02-15]
        // WHY: Shopify peut ventiler la remise commande sur toutes les lignes dans cart.js,
        // ce qui casse l'affichage (ex: 7,99 + 15,99). On neutralise cette ventilation.
        // IMPACT: lignes non-upsell restent au prix catalogue, et seule la ligne upsell prend -8€.
        displayPrice = it.original_line_price + extraTotal;
        originalDisplayPrice = displayPrice;
      }

      // Compare-at catalogue (prix barré boutique) même sans code promo actif
      var vid2 = parseInt((it && (it.id || it.variant_id)) || 0, 10) || 0;
      var compareUnit = vid2 ? (parseInt(compareAtByVariantId[vid2] || '0', 10) || 0) : 0;
      if (compareUnit > 0) {
        var compareLine = (compareUnit * qty) + extraTotal;
        if (compareLine > originalDisplayPrice) {
          originalDisplayPrice = compareLine;
        }
      }

      // [ANNOTATION | DATE: 2026-02-15]
      // WHY: le code promo commande -8€ n'est pas toujours ventile par ligne dans l'affichage drawer.
      // On force l'affichage marketing attendu: ligne upsell 19,99€ -> 11,99€.
      // DO NOT CHANGE: appliquer une seule fois par commande (pas par article) pour rester coherent avec la promo.
      // IMPACT: prix ligne et total drawer alignes avec la promesse upsell.
      if (isUpsellLine && forceUpsellVisualPricing && upsellDiscountRemaining > 0) {
        var appliedUpsellDiscount = Math.min(upsellDiscountRemaining, displayPrice);
        displayPrice = Math.max(0, displayPrice - appliedUpsellDiscount);
        upsellDiscountRemaining -= appliedUpsellDiscount;
      }

      correctedTotal += displayPrice;
      originalTotal += originalDisplayPrice;
      // ----------------------------------------------------

      if (priceEl) {
        var priceHtml = '';

        // Prix barré : toujours prix affiché + 10€ (1000 centimes)
        var fakeCompare = displayPrice + (1000 * qty);
        fakeCompareTotal += fakeCompare;
        priceHtml += '<del style="font-size:12px;opacity:.45;margin-right:5px;">'
          + formatMoney(fakeCompare)
          + '</del>';

        priceHtml += formatMoney(displayPrice);
        priceEl.innerHTML = priceHtml;
      }

      frag.appendChild(node);
    }

    /* [ANNOTATION | DATE: 2026-04-05]
       WHY: quand l'offre est active (offerOnlyCart), on regroupe les items offre
       dans UNE SEULE carte sombre avec le badge "OFFRE DÉCOUVERTE" et le prix total.
       Quand l'offre n'est pas active, chaque item est une carte normale individuelle.
       IMPACT: rendu cohérent — une seule "offre" = une seule carte visuellement. */
    if (offerOnlyCart) {
      var offerNodes = [];
      var otherNodes = [];
      var child = frag.firstChild;
      while (child) {
        var next = child.nextSibling;
        if (child.nodeType === 1 && child.getAttribute && child.getAttribute('data-offer-line') === '1') {
          /* Remove individual offer styling — they'll be inside the group card */
          child.classList.remove('is-offer-line');
          child.style.margin = '0';
          child.style.padding = '6px 0';
          child.style.border = 'none';
          child.style.borderRadius = '0';
          child.style.background = 'transparent';
          child.style.boxShadow = 'none';
          child.style.overflow = 'visible';
          /* Remove individual ::before badge via attribute */
          child.setAttribute('data-offer-grouped', '1');
          offerNodes.push(child);
        } else {
          otherNodes.push(child);
        }
        child = next;
      }

      if (offerNodes.length) {
        var groupCard = document.createElement('div');
        groupCard.className = 'cd-offer-group';
        /* Header with badge + price */
        var groupHeader = document.createElement('div');
        groupHeader.className = 'cd-offer-group__head';
        var _offerGroupPrice = _offerType === '4' ? '39,99\u20ac' : '27,99\u20ac';
        var _offerGroupLabel = _offerType === '4' ? '4 MAILLOTS' : '2 MAILLOTS';
        groupHeader.innerHTML =
          '<span class="cd-offer-group__badge">OFFRE D\u00c9COUVERTE \u2014 ' + _offerGroupLabel + '</span>' +
          '<span class="cd-offer-group__price">' + _offerGroupPrice + '</span>';
        groupCard.appendChild(groupHeader);
        for (var og = 0; og < offerNodes.length; og++) {
          groupCard.appendChild(offerNodes[og]);
        }
        /* Rebuild frag */
        frag = document.createDocumentFragment();
        frag.appendChild(groupCard);
        for (var on2 = 0; on2 < otherNodes.length; on2++) {
          frag.appendChild(otherNodes[on2]);
        }
      }
    }

    safeReplaceChildren(itemsWrap, frag);

    /* Prix barré = somme des fakeCompare de chaque ligne (accumulé pendant le rendu) */
    var subtotalOriginal = fakeCompareTotal > correctedTotal ? fakeCompareTotal : 0;
    animateSubtotalCounter(subtotal, correctedTotal, subtotalOriginal);
    var savedCents = Math.max(0, fakeCompareTotal - correctedTotal);
    if (savingsEl) {

      if (savedCents > 0) {
        var eq = savedCents / BASE_JERSEY_PRICE_CENTS;
        var eqText = formatFrDecimal(eq, 1);
        var unit = (Math.abs(eq - 1) < 0.05) ? 'maillot' : 'maillots';
        savingsEl.textContent = 'Tu économises ' + formatMoney(savedCents) + ' (≈ ' + eqText + ' ' + unit + ')';
        savingsEl.style.display = '';

        /* Disparaît après 10s */
        if (savingsEl._hideTimer) clearTimeout(savingsEl._hideTimer);
        savingsEl._hideTimer = setTimeout(function() {
          savingsEl.style.transition = 'opacity .4s';
          savingsEl.style.opacity = '0';
          setTimeout(function() { savingsEl.style.display = 'none'; savingsEl.style.opacity = ''; savingsEl.style.transition = ''; }, 400);
        }, 10000);
      } else {
        savingsEl.style.display = 'none';
        savingsEl.textContent = '';
      }
    }
    renderCartGoalProgress(progressSlot, cart);

    /* [ANNOTATION | DATE: 2026-04-05]
       WHY: le label "Offre Découverte activée" doit être basé sur la VALIDITÉ réelle de l'offre
       (items offre >= 2 ET 0 items normaux), pas sur discount_codes qui peut être en retard
       à cause du sync asynchrone. Sinon le label persiste après ajout d'un maillot normal.
       IMPACT: label disparaît immédiatement quand l'offre est invalidée. */
    if (discountMsg) {
      var _hk2 = [57,75,65,87,84,72,81,80,49,83,68,65];
      var _hc2 = _hk2.map(function(c){ return String.fromCharCode(c); }).join('');
      var offerCount2 = 0;
      var normalCount2 = 0;
      if (cart && cart.items) {
        for (var dc = 0; dc < cart.items.length; dc++) {
          if (cart.items[dc].properties && cart.items[dc].properties._offer === 'decouverte') {
            offerCount2 += cart.items[dc].quantity;
          } else {
            normalCount2 += cart.items[dc].quantity;
          }
        }
      }
      var _hc4 = '05CRANPQ3ED8';
      var offerCodePresent = !!(cart.discount_codes && cart.discount_codes.some(function(d){ return d.code === _hc2 || d.code === _hc4; }));
      var _dmOfferType = '2';
      try { _dmOfferType = sessionStorage.getItem('covred_offer_type') || '2'; } catch(ex){}
      var _dmReqQty = _dmOfferType === '4' ? 4 : 2;
      var offerIsValid = offerCount2 >= _dmReqQty && normalCount2 === 0 && offerCodePresent;

      if (offerIsValid) {
        var _dmLabel = _dmOfferType === '4' ? 'Offre D\u00e9couverte activ\u00e9e \u2014 4 maillots' : 'Offre D\u00e9couverte activ\u00e9e';
        discountMsg.innerHTML = '<span style="color:#31d39d;font-weight:600;">' + _dmLabel + '</span>';
      } else if (cart.discount_codes && cart.discount_codes.length) {
        var visibleCodes3 = cart.discount_codes.filter(function(d){ return d.code !== _hc2; });
        if (visibleCodes3.length) {
          discountMsg.innerHTML = 'Code appliqu\u00e9 : <strong>' + escapeHtml(visibleCodes3.map(function(d){ return d.code; }).join(', ')) + '</strong>';
        } else {
          discountMsg.innerHTML = '';
        }
      } else {
        discountMsg.innerHTML = '';
      }
    }

    if (upsellNoticeEl) {
      var count = getNonWarrantyItemCount(cart);
      var shouldWarnUpsellInvalid = hasUpsell && count > 2;
      if (shouldWarnUpsellInvalid) {
        // [ANNOTATION | DATE: 2026-02-15]
        // WHY: notification fluide (fade + slide) et temporaire.
        if (!isUpsellInvalidNoticeShown()) {
          showUpsellNotice(
            upsellNoticeEl,
            "L'offre spéciale n'est plus valide car un article supplémentaire a été ajouté.",
            4200
          );
          setUpsellInvalidNoticeShown(true);
        }
      } else {
        clearUpsellNotice(upsellNoticeEl);
        setUpsellInvalidNoticeShown(false);
      }
    }
  }

  function renderLatest(cartPromise, opts) {
    opts = opts || {};
    var token = ++renderToken;
    var loadingTicket = ++drawerLoadingTicket;
    if (!opts.silent) setDrawerLoading(true, loadingTicket);

    /* [PHASE 5A.1] cleanupOrphanWarrantyLines() retiré — code warranty supprimé */
    return Promise.resolve(cartPromise).then(function (cart) {
      return clearUpsellCodeIfInvalid(cart);
    }).then(function (cart) {
      if (token !== renderToken) return; // ignore réponses anciennes
      renderCart(cart);
      scheduleAfterRender();
      if (!opts.silent) setDrawerLoading(false);

      /* [ANNOTATION | DATE: 2026-04-05]
         WHY: synchroniser TOUTES les barres de progression du site après chaque rendu cart drawer.
         - free-shipping bar (theme.js) : utilise cart.total_price
         - bottom promo pill : utilise cart.item_count (se rafraîchit via event)
         - cart count badges : doivent refléter le vrai item_count
         IMPACT: zéro incohérence entre les différentes UI du site. */
      try {
        if (window.theme && theme.freeShipping && typeof theme.freeShipping.load === 'function') {
          theme.freeShipping.load(cart);
        }
      } catch(ex){ console.warn('[cart-drawer] freeShipping', ex); }
      try {
        document.dispatchEvent(new CustomEvent('cart:updated'));
        document.dispatchEvent(new CustomEvent('cart-drawer:updated'));
      } catch(ex){ console.warn('[cart-drawer] events', ex); }
      try {
        var badges = document.querySelectorAll('[data-cart-count-badge], .js-cart-count');
        for (var bi = 0; bi < badges.length; bi++) {
          badges[bi].textContent = String(cart.item_count || 0);
        }
      } catch(ex){ console.warn('[cart-drawer] badges', ex); }

      // [ANNOTATION | DATE: 2026-02-15]
      // WHY: ne jamais bloquer le premier affichage du drawer avec des fetchs catalogue lourds.
      // On précharge suggestion upsell + compare_at en arrière-plan puis on rerender si nécessaire.
      if (!opts.skipWarmup) {
        Promise.resolve()
          .then(function () {
            return Promise.all([
              prefetchUpsellSuggestionForCart(cart),
              prefetchCompareAtForCart(cart)
            ]);
          })
          .then(function (flags) {
            if (token !== renderToken) return;
            // [ANNOTATION | DATE: 2026-02-16]
            // WHY: rerender seulement si prefetch a apporté une vraie donnée nouvelle.
            // IMPACT: moins de travail DOM, animations plus fluides.
            var hasNewData = !!(flags && (flags[0] || flags[1]));
            if (!hasNewData) return;
            renderCart(cart);
            scheduleAfterRender();
          })
          .catch(function () { /* ignore background warmup failures */ });
      }
    }).catch(function (e) {
      if (token === renderToken && !opts.silent) setDrawerLoading(false);
      if (e && e.name === 'AbortError') return;
    });
  }

  // -------------------------
  // Open / close drawer
  // -------------------------
  function markTiming(label) {
    var t = Date.now();
    try {
      sessionStorage.setItem('covred_timing_label', label);
      sessionStorage.setItem('covred_timing_start', String(t));
    } catch (e) {}
  }

  function readTiming() {
    try {
      var start = parseInt(sessionStorage.getItem('covred_timing_start') || '0', 10);
      var label = sessionStorage.getItem('covred_timing_label') || '';
      return { start: isFinite(start) ? start : 0, label: label };
    } catch (e) {
      return { start: 0, label: '' };
    }
  }

  function logTiming(phase) {
    var t = readTiming();
    if (!t.start) return;
    var delta = Date.now() - t.start;
    if (window.COVRED_DEBUG) {
      try { console.info('[COVRED timing]', phase + ':', delta + 'ms', '(from ' + t.label + ')'); } catch (e) {}
    }
  }

  function openDrawer() {
    var dom = getDom();
    if (!dom || !dom.drawer) return;

    drawerOpenSequence += 1;
    dom.drawer.classList.add('is-open');
    dom.drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-open');

    /* [PHASE 4.3] Prefetch /checkout déclenché au HOVER du bouton checkout
       (dans bindCheckoutOverlay), pas à chaque ouverture du drawer.
       Avant : 100% des ouvertures déclenchaient un prefetch même si l'utilisateur
       fermait sans checkouter (waste bandwidth + serveur).
       Maintenant : déclenché uniquement à l'intent réel (mouseenter checkout button). */

    // Affiche immédiatement le cache si on l'a
    if (lastCart) renderCart(lastCart);

    // Abort l'ancien /cart.js si l'utilisateur spam
    if (cartFetchAbort) {
      try { cartFetchAbort.abort(); } catch (e) {}
    }
    cartFetchAbort = (typeof AbortController !== 'undefined') ? new AbortController() : null;

    var signal = cartFetchAbort ? cartFetchAbort.signal : undefined;
    renderLatest(fetchCart(signal));
  }

  function closeDrawer() {
    var dom = getDom();
    if (!dom || !dom.drawer) return;

    setDrawerLoading(false);
    /* [PHASE 5A.1] setWarrantyPopupOpenState() retiré — code warranty supprimé */
    dom.drawer.classList.remove('is-open');
    dom.drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-drawer-open');
  }

  // -------------------------
  // Bindings
  // -------------------------
  /* Named handler pour pouvoir cleanup si besoin */
  function _onEscapeKey(e) { if (e.key === 'Escape') closeDrawer(); }
  var _drawerEventsBound = false;

  function bindDrawerEvents() {
    if (_drawerEventsBound) return;
    _drawerEventsBound = true;

    var dom = getDom();
    if (!dom || !dom.drawer) return;

    if (dom.overlay) dom.overlay.addEventListener('click', closeDrawer);
    if (dom.closeBtn) dom.closeBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', _onEscapeKey, { passive: true });
  }

  function bindDiscountCode() {
    var dom = getDom();
    if (!dom || !dom.drawer) return;

    var wrap = dom.discountWrap;
    var toggle = dom.discountToggle;
    var btn = dom.discountBtn;
    var input = dom.discountInput;
    var msg = dom.discountMsg;

    // Toggle discount fields visibility
    var discountFields = qs('#CartDrawerDiscountFields', dom.drawer);
    if (toggle && discountFields) {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.addEventListener('click', function () {
        var isHidden = discountFields.style.display === 'none' || discountFields.style.display === '';
        discountFields.style.display = isHidden ? 'block' : 'none';
        toggle.setAttribute('aria-expanded', isHidden ? 'true' : 'false');
      });
    }

    if (!btn || !input) return;

    /* [ANNOTATION | DATE: 2026-04-05]
       WHY: le code offre découverte ne doit JAMAIS être saisi manuellement.
       Il est exclusivement appliqué via le bottom-sheet offre.
       On bloque la saisie en comparant le code saisi avec le code obfusqué.
       IMPACT: impossible de contourner l'offre en tapant le code à la main. */
    var _bdk = [57,75,65,87,84,72,81,80,49,83,68,65];
    var _bdc = _bdk.map(function(c){ return String.fromCharCode(c); }).join('');
    btn.addEventListener('click', function () {
      var code = (input.value || '').trim();

      if (!code) {
        if (msg) msg.textContent = 'Entre un code.';
        return;
      }

      if (code.toUpperCase() === _bdc) {
        if (msg) msg.textContent = 'Ce code n\u2019est pas utilisable ici.';
        input.value = '';
        return;
      }

      if (msg) msg.textContent = 'Application du code…';

      try {
        localStorage.setItem('covred_reopen_drawer', '1');
      } catch (e) {}

      window.location.href = '/discount/' + encodeURIComponent(code);
    });
  }

  function bindEmptyOfferDiscountActivation() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-empty-offer-code]');
      if (!btn) return;
      e.preventDefault();
      var code = String(btn.getAttribute('data-empty-offer-code') || '').trim();
      if (!code) return;

      var dom = getDom();
      var wrap = dom && dom.discountWrap ? dom.discountWrap : null;
      var toggle = dom && dom.discountToggle ? dom.discountToggle : null;
      var input = dom && dom.discountInput ? dom.discountInput : null;
      var msg = dom && dom.discountMsg ? dom.discountMsg : null;

      var discFieldsAuto = document.getElementById('CartDrawerDiscountFields');
      if (discFieldsAuto) discFieldsAuto.style.display = 'block';
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      if (input) input.value = code;
      if (msg) msg.textContent = 'Activation du code…';

      try {
        localStorage.setItem('covred_reopen_drawer', '1');
      } catch (err) {}

      var minQty = 0;
      var codeUpper = String(code).toUpperCase();
      if (DRAWER_PROMO_MIN_QTY_BY_CODE[codeUpper]) minQty = parseInt(DRAWER_PROMO_MIN_QTY_BY_CODE[codeUpper], 10) || 0;
      var holdMs = 2400;
      showCartLoadingOverlay({
        title: minQty
          ? ('Code activé : remise bloquée en dessous de ' + minQty + ' maillots')
          : 'Activation de l\u2019offre promo',
        sub: minQty
          ? ('Important : tant que ton panier contient moins de ' + minQty + ' maillots, la réduction reste à 0€.')
          : 'Code en cours d\u2019activation...'
        ,
        step: minQty
          ? ('Ajoute ' + minQty + ' maillots minimum pour déclencher la remise.')
          : 'Activation du code...'
      });

      var redirectPath = (window.location.pathname || '/') + (window.location.search || '');
      setTimeout(function () {
        window.location.href = buildDiscountRedirectUrl(code, redirectPath);
      }, holdMs);
    });
  }

  function bindItemActions() {
    document.addEventListener('click', function (e) {

      // ✕ suppression (quantity = 0)
      var removeBtn = e.target.closest('.cart-drawer__remove');
      if (removeBtn) {
        /* [ANNOTATION | DATE: 2026-04-15] PHASE 2A.2 fix
           WHY: avant ce fix, il fallait 2 clicks pour supprimer un item. Le 1er click
           envoyait bien le POST /cart/change.js, mais sans preventDefault/stopPropagation,
           un autre handler global (ou le bubbling) re-déclenchait potentiellement le
           render, et le re-render remplaçait le bouton dans le DOM avant que l'utilisateur
           voie le feedback → impression que le 1er click n'a rien fait.
           IMPACT: suppression instantanée au 1er click, pas de double-click. */
        e.preventDefault();
        e.stopPropagation();
        /* Empêche tout double-click pendant l'opération en cours */
        if (removeBtn.disabled || removeBtn.dataset.removing === '1') return;

        var item = removeBtn.closest('.cart-drawer__item');
        var key = item && item.getAttribute('data-key');
        if (!key) return;

        /* Lock + feedback visuel immédiat */
        removeBtn.disabled = true;
        removeBtn.dataset.removing = '1';
        removeBtn.style.pointerEvents = 'none';
        if (item) {
          item.style.opacity = '0.4';
          item.style.transition = 'opacity .15s';
          item.style.pointerEvents = 'none';
        }

        renderLatest(changeCartLine(key, 0));
        return;
      }

      // + / - quantité
      var qtyBtn = e.target.closest('.cd-qty-btn');
      if (!qtyBtn) return;

      var item2 = qtyBtn.closest('.cart-drawer__item');
      if (!item2) return;

      // [ANNOTATION | DATE: 2026-02-16]
      // WHY: lookup O(1) des lignes upsell au lieu de scanner tout le panier à chaque clic +/-.
      // IMPACT: interactions quantité plus réactives.
      var blockedUpsell = !!(
        item2.querySelector('.cd-qty-input[readonly]') ||
        (item2.getAttribute('data-key') && upsellLineKeyLookup[item2.getAttribute('data-key')])
      );
      if (blockedUpsell) return;

      var key2 = item2.getAttribute('data-key');
      var qtyInput = item2.querySelector('.cd-qty-input');
      if (!key2 || !qtyInput) return;

      var currentQty = parseInt(qtyInput.value, 10);
      if (isNaN(currentQty)) currentQty = 0;

      var delta = parseInt(qtyBtn.getAttribute('data-dir'), 10);
      var newQty = currentQty + delta;
      if (newQty < 0) return;

      // Update input immediately (optimistic UI)
      qtyInput.value = newQty;

      // Debounce: only fire API call after 400ms idle (handles rapid +++ clicks)
      clearTimeout(item2._qtyDebounce);
      item2._qtyDebounce = setTimeout(function() {
        renderLatest(changeCartLine(key2, newQty));
      }, 400);
    });
  }

  function bindQtyInput() {
    document.addEventListener('change', function (e) {
      if (!e.target.matches('.cd-qty-input')) return;

      var item = e.target.closest('.cart-drawer__item');
      var key = item && item.getAttribute('data-key');
      if (!key) return;

      if (e.target.matches('[readonly]')) return;

      var val = parseInt(e.target.value, 10);
      if (isNaN(val) || val < 0) return;
      if (val > 999) { e.target.value = 999; val = 999; }

      // ✅ 1 seule requête, et anti-race
      renderLatest(changeCartLine(key, val));
    });
  }

  function bindUpsellSizeSelection() {
    document.addEventListener('click', function (e) {
      var sizeBtn = e.target.closest('.cart-drawer__upsell-size-btn');
      if (!sizeBtn) return;

      var size = String(sizeBtn.getAttribute('data-upsell-size') || '').trim();
      if (!size) return;
      setSelectedUpsellSize(size);

      var card = sizeBtn.closest('#CartDrawerUpsellCard');
      if (!card) return;
      var all = card.querySelectorAll('.cart-drawer__upsell-size-btn');
      for (var i = 0; i < all.length; i++) {
        all[i].classList.remove('is-active');
      }
      sizeBtn.classList.add('is-active');
    });
  }

  function bindUpsellCarouselNext() {
    document.addEventListener('click', function (e) {
      var nextBtn = e.target.closest('#CartDrawerUpsellNext');
      if (!nextBtn) return;
      e.preventDefault();
      if (!Array.isArray(currentUpsellSuggestions) || currentUpsellSuggestions.length < 2) return;
      var current = getUpsellCardIndex();
      var next = (current + 1) % currentUpsellSuggestions.length;
      setUpsellCardIndex(next);
      var dom = getDom();
      if (!dom || !dom.upsellCard) return;
      renderUpsellCard(dom.upsellCard, lastCart || null);
    });
  }

  function bindNeutralAddon() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#CartDrawerAddNeutral1199');
      if (!btn) return;
      if (btn.disabled) return;
      if (!canOfferUpsell(lastCart)) return;
      var selectedUpsellSize = getSelectedUpsellSize();
      var upsellCardEl = btn.closest('#CartDrawerUpsellCard');
      var clickStartedAt = Date.now();
      var minFeedbackMs = 520;
      var clickBurstTimer = null;

      // [ANNOTATION | DATE: 2026-02-16]
      // WHY: feedback visuel instantané dès le clic (avant le rerender du panier).
      // IMPACT: sensation de réactivité immédiate sur le CTA offre spéciale.
      if (e && typeof e.clientX === 'number' && typeof e.clientY === 'number') {
        var rect = btn.getBoundingClientRect();
        btn.style.setProperty('--cd-click-x', (e.clientX - rect.left) + 'px');
        btn.style.setProperty('--cd-click-y', (e.clientY - rect.top) + 'px');
      } else {
        btn.style.setProperty('--cd-click-x', '50%');
        btn.style.setProperty('--cd-click-y', '50%');
      }
      btn.classList.add('is-click-burst');
      if (upsellCardEl) upsellCardEl.classList.add('is-adding');
      clickBurstTimer = setTimeout(function () {
        btn.classList.remove('is-click-burst');
        clickBurstTimer = null;
      }, 620);

      btn.disabled = true;
      btn.classList.add('is-loading');

      resolveNeutralVariantForSize(selectedUpsellSize, getActiveUpsellSuggestion()).then(function (variantId) {
        if (!variantId) {
          throw new Error('Aucun produit offre spéciale disponible.');
        }

        return fetchJSON('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1,
              properties: {
                _covred_neutral_addon: '1199',
                _covred_upsell_offer: '1'
              }
            }]
          })
        }).then(function () {
          setUpsellSessionActive(true);
          return fetchJSON('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            credentials: 'same-origin',
            body: JSON.stringify({ discount: UPSELL_DISCOUNT_CODE })
          }).catch(function () {
            return null;
          });
        }).then(function () {
          // [ANNOTATION | DATE: 2026-02-16]
          // WHY: garantir que l'animation "ajout en cours" soit perceptible même si le réseau répond très vite.
          // IMPACT: suppression de l'effet "rien ne se passe" au clic.
          markUpsellJustAdded();
          var elapsed = Date.now() - clickStartedAt;
          var waitMs = Math.max(0, minFeedbackMs - elapsed);
          if (!waitMs) return renderLatest(fetchCart());
          return new Promise(function (resolve) {
            setTimeout(resolve, waitMs);
          }).then(function () {
            return renderLatest(fetchCart());
          });
        });
      }).catch(function (err) {
        alert(err && err.message ? err.message : 'Impossible d\u2019ajouter le produit offre spéciale');
      }).finally(function () {
        // [ANNOTATION | DATE: 2026-02-16]
        // WHY: éviter les timeouts pendants si le cycle se termine avant la fin de l'animation.
        // IMPACT: même rendu, moins de callbacks inutiles.
        if (clickBurstTimer) {
          clearTimeout(clickBurstTimer);
          clickBurstTimer = null;
        }
        btn.disabled = false;
        btn.classList.remove('is-loading');
        btn.classList.remove('is-click-burst');
        if (upsellCardEl) upsellCardEl.classList.remove('is-adding');
      });
    });
  }

  /* [PHASE 5A.1] Bloc warranty supprimé — code mort. bindWarrantyUpsell retiré. */

  function killThemeCartTriggers() {
    // Sur clic icône panier du thème -> on bloque son mini-cart ET on ouvre Covred
    document.addEventListener('click', function (e) {
      var t = e.target.closest('.js-toggle-cart, .js-mini-cart, .site-header__cart, [data-cartmini="true"], .cardraw');
      if (!t) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      openDrawer();
    }, true);
  }

  function forceDrawerOnAddToCartClick() {
    // Intercepte le clic ATC en capture → AJAX + ouvre le drawer au lieu de naviguer.
    // stopImmediatePropagation bloque Easify/YMQ/tout autre app de rediriger vers /cart.
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('button[type="submit"], input[type="submit"]');
      if (!btn) return;

      var form = btn.closest('form');
      if (!form) return;

      var hasVariantId = form.querySelector('input[name="id"], select[name="id"]');
      if (!hasVariantId) return;

      if (form.querySelector('input[name="updates[]"]')) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      /* Retirer la classe Easify du bouton pour qu'elle ne bloque plus les prochains clics */
      if (btn.classList.contains('tpo_add-to-cart')) btn.classList.remove('tpo_add-to-cart');

      setTimeout(function() {
        addToCartViaAjax(form)
          .then(function () {
            openDrawer();
          })
          .catch(function (err) {
            console.warn('Add to cart failed:', err);
            alert(err && err.message ? err.message : 'Erreur ajout panier');
          });
      }, 50);
    }, true);

    // Bloquer aussi le submit natif du form (Easify peut appeler form.submit() directement)
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.tagName || form.tagName !== 'FORM') return;
      var hasVariantId = form.querySelector('input[name="id"], select[name="id"]');
      if (!hasVariantId) return;
      if (form.querySelector('input[name="updates[]"]')) return;
      e.preventDefault();
    }, true);
  }

  // Précharge le cart au chargement de la page pour affichage instantané
  function primeCart() {
    fetchCart().then(function (cart) {
      lastCart = cart || null;
    }).catch(function () { /* ignore */ });
  }

  // Prefetch /checkout dès que le drawer s'ouvre.
  // Le browser pré-charge les DNS + TLS + HTML → le clic checkout sera quasi instantané.
  var checkoutPrefetched = false;
  function prefetchCheckout() {
    if (checkoutPrefetched) return;
    checkoutPrefetched = true;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = '/checkout';
    link.as = 'document';
    document.head.appendChild(link);
  }

  // Quand le client clique "Passer au paiement" : overlay plein écran avec spinner → navigation
  function bindCheckoutOverlay() {
    /* [PHASE 4.3] Prefetch /checkout au mouseenter / touchstart du bouton (intent réel)
       Plus efficace que prefetch à chaque ouverture du drawer. */
    document.addEventListener('mouseenter', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('#CartDrawerCheckout');
      if (btn) prefetchCheckout();
    }, true);
    document.addEventListener('touchstart', function (e) {
      var btn = e.target.closest('#CartDrawerCheckout');
      if (btn) prefetchCheckout();
    }, { capture: true, passive: true });

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('#CartDrawerCheckout');
      if (!btn) return;
      if (btn.getAttribute('aria-disabled') === 'true') return;

      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      showCheckoutLoadingScreen();
      window.location.href = '/checkout';
    }, true);
  }

  // Écran de chargement plein écran affiché au clic sur "Passer au paiement"
  // Remplace l'ancienne popup window — plus fiable, plus élégant, jamais bloqué par le navigateur
  function showCheckoutLoadingScreen() {
    if (document.getElementById('covred-checkout-loading')) return;

    var overlay = document.createElement('div');
    overlay.id = 'covred-checkout-loading';
    overlay.setAttribute('aria-live', 'assertive');
    overlay.setAttribute('role', 'status');
    overlay.innerHTML =
      '<div class="covred-checkout-loading__inner">' +
        '<img src="https://cdn.shopify.com/s/files/1/0711/9408/3490/files/Noir_Rond_Logo_Boulangerie_Marque_074237a3-d277-4906-a304-8b9038f23a6e.png?v=1774952913" alt="Covred" class="covred-checkout-loading__logo" width="48" height="48" decoding="async">' +
        '<div class="covred-checkout-loading__bar"><div class="covred-checkout-loading__bar-fill"></div></div>' +
        '<p class="covred-checkout-loading__title">Préparation de votre commande</p>' +
        '<p class="covred-checkout-loading__sub"><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg> Paiement 100% sécurisé</p>' +
      '</div>';

    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';
  }

  // Overlay pour masquer le panier thème pendant l'enchaînement auto
  function showCartLoadingOverlay(opts) {
    if (document.getElementById('covred-cart-loading')) return;
    var titleText = (opts && opts.title) ? String(opts.title) : 'Nous finalisons votre commande';

    var style = document.createElement('style');
    style.textContent =
      '#covred-cart-loading{position:fixed;inset:0;z-index:99999;display:flex;align-items:center;justify-content:center;background:#0a0a0a;}' +
      '#covred-cart-loading .covred-cl-inner{display:flex;flex-direction:column;align-items:center;gap:14px;text-align:center;max-width:280px;}' +
      '#covred-cart-loading .covred-cl-check{width:40px;height:40px;border-radius:999px;background:rgba(49,211,157,.12);border:2px solid #31d39d;display:flex;align-items:center;justify-content:center;animation:covred-cl-pop .4s cubic-bezier(.22,.8,.2,1);}' +
      '#covred-cart-loading .covred-cl-check svg{width:20px;height:20px;stroke:#31d39d;stroke-width:2.5;fill:none;stroke-linecap:round;stroke-linejoin:round;}' +
      '@keyframes covred-cl-pop{from{transform:scale(.6);opacity:0}to{transform:scale(1);opacity:1}}' +
      '#covred-cart-loading .covred-cl-title{font-size:16px;font-weight:800;color:#fff;margin:0;}' +
      '#covred-cart-loading .covred-cl-sub{font-size:12px;font-weight:500;color:rgba(255,255,255,.45);margin:0;}';
    document.head.appendChild(style);

    var overlay = document.createElement('div');
    overlay.id = 'covred-cart-loading';
    overlay.innerHTML =
      '<div class="covred-cl-inner">' +
        '<div class="covred-cl-check"><svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg></div>' +
        '<p class="covred-cl-title">' + escapeHtml(titleText) + '</p>' +
        '<p class="covred-cl-sub">Mise à jour de votre panier</p>' +
      '</div>';
    document.body.appendChild(overlay);

    document.documentElement.style.overflow = 'hidden';
  }

  function init() {
    killThemeCartTriggers();
    forceDrawerOnAddToCartClick();

    bindDrawerEvents();
    bindDiscountCode();
    bindEmptyOfferDiscountActivation();
    bindItemActions();
    bindQtyInput();
    bindUpsellSizeSelection();
    bindUpsellCarouselNext();
    bindNeutralAddon();
    /* [PHASE 5A.1] bindWarrantyUpsell() retiré — code warranty supprimé */
    bindCheckoutOverlay();

    window.COVRED_CART_DRAWER = { open: openDrawer, close: closeDrawer };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      primeCart();
    });
  } else {
    init();
    primeCart();
  }

})();
